<template>
  <!-- 新建提货指令 -->
  <div class="contentBox">
    <div style="height: 60px; width: 100%" v-if="editable"></div>
    <div class="topBtns" v-if="editable">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit"
        >保存</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="saveAndPrintIt('套打')"
        >保存并套打</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="saveAndPrintIt('全打')"
        >保存并全打</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="printIt('标签打印')"
        >打印标签</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="printIt('回扣打印')"
        >打印回扣凭证</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="printIt('信封打印')"
        >打印信封</el-button
      >
      <el-button style="margin-top: 10px" class="glo_bg" @click="submit"
        >保存并过账</el-button
      >
      <el-button style="margin-top: 10px" class="glo_bg" @click="setEnter"
        >界面光标设置</el-button
      >
    </div>
    <div class="form_head" v-loading="loadingDetail">
      <div class="waybill_Type">{{ waybillStatus }}</div>
      <el-form
        label-width="100px"
        class="head_formBox glo_formBox"
        ref="form1"
        :model="baseInfo"
        :rules="feeCheckIn ? {} : rule1"
      >
        <el-form-item label="运单号:" prop="waybillNumber">
          <el-input
            :disabled="disabledSee || feeCheckIn"
            v-model="baseInfo.waybillNumber"
            placeholder="不录入则自动生成"
            clearable
            ref="k1"
            @keyup.enter.native="enterFns($event, 'k1')"
          ></el-input>
        </el-form-item>
        <el-form-item label="中转单号:" prop="transferNumber">
          <el-input
            :disabled="disabledSee || feeCheckIn"
            v-model="baseInfo.transferNumber"
            placeholder="请输入"
            clearable
            ref="k2"
            @keyup.enter.native="enterFns($event, 'k2')"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户单号:" prop="customerOrderNumber">
          <el-input
            :disabled="disabledSee || feeCheckIn"
            v-model="baseInfo.customerOrderNumber"
            placeholder="请输入"
            clearable
            ref="k3"
            @keyup.enter.native="enterFns($event, 'k3')"
          ></el-input>
        </el-form-item>
        <el-form-item label="业务日期:" prop="businessDate">
          <el-date-picker
            v-model="baseInfo.businessDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="datetime"
            placeholder="选择日期"
            :disabled="disabledSee || feeCheckIn"
            ref="k4"
            @blur="enterFns(baseInfo.businessDate, 'k4', 'datetime')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开单网点:" prop="receiveOrderDeptId">
          <el-select
            disabled
            filterable
            clearable
            v-model="baseInfo.receiveOrderDeptId"
            placeholder="请选择"
            ref="k5"
            @keyup.enter.native="enterFns(baseInfo.destCity, 'k5', 'select')"
          >
            <el-option
              v-for="dept in businessDepts"
              :key="dept.deptId"
              :label="dept.deptName"
              :value="dept.deptId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="all_div" v-loading="loadingDetail">
      <!-- 基本信息 -->
      <div class="infoDiv">
        <div class="h3title">基础信息</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form2"
            :model="baseInfo"
            :rules="feeCheckIn ? {} : rule2"
            show-message
          >
            <el-form-item label="目的城市:" prop="destCity">
              <el-select
                clearable
                placeholder="请输入并选择"
                filterable
                remote
                v-model="baseInfo.destCity"
                :remote-method="getDestCities"
                :loading="destCityLoading"
                @change="changeDestCity($event, 'k6')"
                @clear="clearDestCity"
                :disabled="disabledSee || feeCheckIn"
                ref="k6"
                @keyup.enter.native="
                  enterFns(baseInfo.destCity, 'k6', 'select')
                "
              >
                <el-option
                  v-for="(city, index) in destCitys"
                  :key="index"
                  :label="city.destCity"
                  :value="city.cityName"
                >
                  <span style="float: left">{{ city.destCity }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    city.adCode
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运输路线:" prop="transportLineId">
              <el-select
                clearable
                placeholder="请输入并选择"
                filterable
                remote
                v-model="baseInfo.transportLineId"
                :loading="transportLineLoading"
                @change="changeTransportLine($event, 'k7')"
                :disabled="disabledSee || feeCheckIn"
                ref="k7"
                @keyup.enter.native="
                  enterFns(baseInfo.transportLineId, 'k7', 'select')
                "
              >
                <el-option
                  v-for="line in lines"
                  :key="line.id"
                  :label="line.lineName"
                  :value="line.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="终端网点:" prop="endDeptId">
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="baseInfo.endDeptId"
                placeholder="请选择"
                @change="changeEndDept($event, 'k8')"
                ref="k8"
                @keyup.enter.native="
                  enterFns(baseInfo.endDeptId, 'k8', 'select')
                "
              >
                <el-option
                  v-for="dept in businessDepts"
                  :key="dept.deptId"
                  :label="dept.deptName"
                  :value="dept.deptId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="发货方式:"
              :required="!feeCheckIn"
              prop="receiveMethodConfDictId"
            >
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="baseInfo.receiveMethodConfDictId"
                placeholder="请选择"
                @change="changeSelectKey($event, 'k9')"
                ref="k9"
                @keyup.enter.native="
                  enterFns(baseInfo.receiveMethodConfDictId, 'k9', 'select')
                "
              >
                <el-option
                  v-for="item in receMethods"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="运输方式:"
              :required="!feeCheckIn"
              prop="transportMethodConfDictId"
            >
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="baseInfo.transportMethodConfDictId"
                placeholder="请选择"
                ref="k10"
                @change="changeSelectKey($event, 'k10')"
                @keyup.enter.native="
                  enterFns(baseInfo.transportMethodConfDictId, 'k10', 'select')
                "
              >
                <el-option
                  v-for="item in transportMethods"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="交货方式:"
              :required="!feeCheckIn"
              prop="sendMethodConfDictId"
            >
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="baseInfo.sendMethodConfDictId"
                placeholder="请选择"
                @change="changeSendMethod_Fn($event, 'k11')"
                ref="k11"
                @keyup.enter.native="
                  enterFns(baseInfo.sendMethodConfDictId, 'k11', 'select')
                "
              >
                <el-option
                  v-for="item in sendMethods"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="回单要求:" prop="rnRequireCount">
              <div class="glo_disFlex" style="padding-right: 3px">
                <el-select
                  style="flex"
                  v-model="baseInfo.rnRequireConfDictId"
                  placeholder="请选择"
                  filterable
                  clearable
                  @change="changeRnRquireConf($event, 'k12')"
                  :disabled="disabledSee || feeCheckIn"
                  ref="k12"
                  @keyup.enter.native="
                    enterFns(baseInfo.rnRequireConfDictId, 'k12', 'select')
                  "
                >
                  <el-option
                    v-for="item in rnRequirements"
                    :key="item.id"
                    :label="item.val"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <el-input
                  class="miniInput"
                  v-model="baseInfo.rnRequireCount"
                  placeholder="份数"
                  type="number"
                  @mousewheel.native.prevent
                  :disabled="disabledSee || feeCheckIn"
                  ref="k13"
                  @keyup.enter.native="enterFns(baseInfo.rnRequireCount, 'k13')"
                ></el-input
                >份
              </div>
            </el-form-item>
            <el-form-item label="订单指令:" prop="commandId">
              <el-select
                v-model="baseInfo.commandId"
                placeholder="请输入或选择"
                clearable
                filterable
                :disabled="disabledSee || feeCheckIn"
                ref="k14"
                @change="changeSelectKey($event, 'k14')"
                @keyup.enter.native="
                  enterFns(baseInfo.commandId, 'k14', 'select')
                "
              >
                <el-option
                  v-for="item in commands"
                  :key="item.commandId"
                  :label="item.number"
                  :value="item.commandId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="textArea"
              style="width: 100%"
              label="备注:"
              prop="remarks"
            >
              <el-input
                :disabled="disabledSee || feeCheckIn"
                placeholder="请输入"
                clearable
                v-model="baseInfo.remarks"
                type="textarea"
                ref="k15"
                @keyup.enter.native="enterFns(baseInfo.rnRequireCount, 'k15')"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 收发信息 -->
      <div class="infoDiv">
        <div class="h3title">收发信息</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form7"
            :model="baseInfo"
            :rules="feeCheckIn ? {} : rule7"
          >
            <el-form-item label="客户类型:" :required="!feeCheckIn">
              <el-radio-group
                :disabled="disabledSee || feeCheckIn"
                v-model="baseInfo.customerType"
                @change="changeCustomerType"
              >
                <el-radio :label="0">散客</el-radio>
                <el-radio :label="1">常客</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="开单客户:"
              :required="baseInfo.customerType == 1"
              v-show="baseInfo.customerType == 1"
              prop="customerId"
            >
              <el-select
                :disabled="disabledSee || feeCheckIn"
                clearable
                filterable
                remote
                allow-create
                :remote-method="remoteMethodCustomer"
                default-first-option
                v-model="baseInfo.customerId"
                placeholder="请选择"
                @change="changeMethodCustomer"
                @focus="focusMethodCustomer"
              >
                <el-option
                  v-for="(item, index) in CustomerLists"
                  :key="index"
                  :label="item.customerName"
                  :value="item.customerId"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="Divider"></div>
          </el-form>
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form3"
            :model="sendAddr"
          >
            <!-- <template v-for="(sendAddr, index) in sendAddrs">
              <div :key="index"> -->
            <el-form-item label="发货人:" prop="contacts">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="sendAddr.contacts"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="发货单位:" prop="company">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="sendAddr.company"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="tel">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="sendAddr.tel"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号码:" prop="idNumber">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="sendAddr.idNumber"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%; border: 0" label="发货地址:">
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="sendAddr.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="sendAddr.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @change="changeCity"
                  @focus="getCityName(sendAddr.provinceName)"
                >
                  <el-option
                    v-for="(item, index) in cityNameList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="sendAddr.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(sendAddr.cityName)"
                  @change="changeArea"
                >
                  <el-option
                    v-for="(item, index) in areaNameList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress addressDetails"
                  v-model="sendAddr.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode(sendAddr.address)"
                ></el-input>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-full-screen"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #409eff;
                    font-weight: bold;
                  "
                  @click="go2AddressAI(1)"
                ></i>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-map-location"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #ff0000;
                    font-weight: bold;
                  "
                  @click="go2Map(1)"
                ></i>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-search"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    color: #7f7f7f;
                    font-weight: bold;
                  "
                  @click="changeRecAddress(1)"
                ></i>
                <div class="checkBox">
                  <el-checkbox
                    :disabled="disabledSee || feeCheckIn"
                    v-model="isAutoAddr_jj"
                    >收录发货地址</el-checkbox
                  >
                </div>
              </div>
            </el-form-item>
            <div class="Divider"></div>
            <!-- </div>
            </template> -->
            <el-form-item label="收货人:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="receiveAddr.contacts"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="收货单位:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="receiveAddr.company"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="receiveAddr.tel"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号码:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="receiveAddr.idNumber"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%; border: 0" label="收货地址:">
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="receiveAddr.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince(1)"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="receiveAddr.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @change="changeCity(1)"
                  @focus="getCityName(receiveAddr.provinceName, 1)"
                >
                  <el-option
                    v-for="(item, index) in cityNameList_1"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="receiveAddr.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(receiveAddr.cityName, 1)"
                  @change="changeArea"
                >
                  <el-option
                    v-for="(item, index) in areaNameList_1"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress addressDetails"
                  v-model="receiveAddr.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode(receiveAddr.address)"
                ></el-input>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-full-screen"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #409eff;
                    font-weight: bold;
                  "
                  @click="go2AddressAI(2)"
                ></i>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-map-location"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #ff0000;
                    font-weight: bold;
                  "
                  @click="go2Map(2)"
                ></i>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-search"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    color: #7f7f7f;
                    font-weight: bold;
                  "
                  @click="changeRecAddress(2)"
                ></i>
                <div class="checkBox">
                  <el-checkbox
                    :disabled="disabledSee || feeCheckIn"
                    v-model="isAutoAddr_sj"
                    >收录收货人信息</el-checkbox
                  >
                </div>
              </div>
            </el-form-item>
            <div class="Divider"></div>
            <el-form-item label="自提电话:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="takeAddr.tel"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item style="flex: 1; border: 0" label="自提地址:">
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="takeAddr.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince(2)"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="takeAddr.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @change="changeCity(2)"
                  @focus="getCityName(takeAddr.provinceName, 2)"
                >
                  <el-option
                    v-for="(item, index) in cityNameList_2"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="takeAddr.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(takeAddr.cityName, 2)"
                  @change="changeArea"
                >
                  <el-option
                    v-for="(item, index) in areaNameList_2"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress addressDetails"
                  v-model="takeAddr.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode(takeAddr.address)"
                ></el-input>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-map-location"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #ff0000;
                    font-weight: bold;
                  "
                  @click="go2Map(3)"
                ></i>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 货物信息 -->
      <div class="infoDiv" id="tables">
        <div class="h3title">货物信息</div>
        <div class="formbox goodsItmes">
          <div class="glo_Table goodsTable">
            <el-table
              :data="sendAddrs_1"
              border
              show-summary
              ref="mytable1"
              :summary-method="getSummaries"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column prop="goodsNumber" label="货物编号">
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="text"
                    v-model="sendAddrs_1[scope.$index].goodsNumber"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="goodsName"
                label="品名"
              >
                <template slot-scope="scope">
                  <el-select
                    :disabled="disabledSee || feeCheckIn"
                    clearable
                    filterable
                    remote
                    allow-create
                    default-first-option
                    placeholder="请选择"
                    v-model="sendAddrs_1[scope.$index].goodsName"
                    :remote-method="
                      (e) => {
                        remoteMethodCategory(e, scope.$index);
                      }
                    "
                    @change="
                      (e) => {
                        changeMethodCategory(e, scope.$index);
                      }
                    "
                    @focus="focusMethodCategory(scope.$index)"
                    @clear="remoteMethodCategory('', scope.$index)"
                  >
                    <el-option
                      v-for="(item2, index2c) in goodsList"
                      :key="index2c"
                      :label="item2.itemName"
                      :value="item2.itemName"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="packageName" label="包装">
                <template slot-scope="scope">
                  <el-select
                    @change="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    v-model="sendAddrs_1[scope.$index].packageName"
                    filterable
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item2, index2c) in packageNameList"
                      :key="index2c"
                      :label="item2.val"
                      :value="item2.val"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="packageCout" label="*件数" sortable>
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].packageCout"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="grossWeight" label="*毛重" sortable>
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].grossWeight"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="netWeight" label="净重" sortable>
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].netWeight"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="volume"
                label="*体积/m³"
                sortable
                width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    @change="calcVolumeWeight(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].volume"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="volumeDivisor"
                label="*体积系数"
                sortable
                width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    @change="calcVolumeWeight(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].volumeDivisor"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="volumeWeight"
                label="体积重量/KG"
                sortable
                width="120"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].volumeWeight"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="billingWeight"
                label="计费重量"
                sortable
                width="120"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].billingWeight"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="specs" label="规格">
                <template slot-scope="scope">
                  <div class="linkTabel" @click="clickSet(scope.$index)">
                    规格
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="packageName" label="重/泡货">
                <template slot-scope="scope">
                  <el-select
                    @change="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    v-model="sendAddrs_1[scope.$index].heavyCargoConfDictId"
                    filterable
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item2, index2c) in heavyCargos"
                      :key="index2c"
                      :label="item2.val"
                      :value="item2.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                v-if="false && !disabledSee && !feeCheckIn"
              >
                <template slot-scope="scope">
                  <div class="iconList">
                    <i
                      v-if="scope.$index == 0"
                      class="el-icon-circle-plus iconSize"
                      @click="AddGoods(scope.$index)"
                    ></i>
                    <el-popconfirm
                      v-else
                      title="确定删除该行货物信息吗"
                      @confirm="delGoods(scope.$index)"
                    >
                      <i slot="reference" class="el-icon-remove iconSize"></i>
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 运输要求 -->
      <div class="infoDiv">
        <div class="h3title">运输要求</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form4"
            :rules="rule4"
            :model="transportInfo"
          >
            <el-form-item label="预计提货时间:">
              <el-date-picker
                :disabled="disabledSee || feeCheckIn"
                v-model="transportInfo.takeTime"
                value-format="yyyy-MM-dd  HH:mm:ss"
                default-time="23:59:59"
                type="datetime"
                placeholder="请选择"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="预计送货时间:">
              <el-date-picker
                :disabled="disabledSee || feeCheckIn"
                v-model="transportInfo.deliveryTime"
                value-format="yyyy-MM-dd  HH:mm:ss"
                default-time="23:59:59"
                type="datetime"
                placeholder="请选择"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="是否入仓:" class="double_item">
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="transportInfo.isIntoStorage"
                placeholder="请选择"
                @change="changeIntoStorage"
              >
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
              </el-select>
              <el-input
                :disabled="disabledSee || feeCheckIn"
                class="second_ipt"
                v-model="transportInfo.intoStorageNumber"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="收货仓号:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="transportInfo.receiveStorageNumber"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <div style="width: 100%; display: flex; align-items: center">
              <el-form-item label="特殊要求:">
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  clearable
                  filterable
                  remote
                  allow-create
                  default-first-option
                  v-model="transportInfo.specialRequire"
                  @change="changeSpecialRequire()"
                  placeholder="请输入或选择"
                >
                  <el-option
                    v-for="(item, index) in specialRequirements"
                    :key="index"
                    :label="item.val"
                    :value="item.val"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-checkbox
                v-model="transportInfo.isUrgent"
                :true-label="1"
                :false-label="0"
                :disabled="disabledSee || feeCheckIn"
                >加急</el-checkbox
              >
              <el-checkbox
                v-model="transportInfo.isWaitNoticeSend"
                :true-label="1"
                :false-label="0"
                :disabled="disabledSee || feeCheckIn"
                >等通知放货</el-checkbox
              >
              <el-checkbox
                v-model="transportInfo.isValuable"
                :true-label="1"
                :false-label="0"
                :disabled="disabledSee || feeCheckIn"
                >贵重</el-checkbox
              >
            </div>
          </el-form>
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form8"
            :rules="baseEdit ? {} : rule8"
            :model="financeInInfo"
          >
            <div style="width: 100%; display: flex">
              <el-form-item
                label="是否投保:"
                class="double_item"
                prop="isInsure"
              >
                <el-select
                  :disabled="disabledSee || baseEdit"
                  filterable
                  clearable
                  v-model="financeInInfo.isInsure"
                  placeholder="请选择"
                  @change="changeInsure"
                >
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="声明价值:"
                prop="declaredValue"
                :required="financeInInfo.isInsure === 1"
              >
                <div style="position: relative">
                  <el-row>
                    <el-col :span="16"
                      ><el-input
                        :disabled="disabledSee || baseEdit"
                        v-model="financeInInfo.declaredValue"
                        type="number"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input
                        :disabled="disabledSee"
                        v-model="financeInInfo.declaredValueRate"
                        type="number"
                        placeholder="请输入"
                        suffix-icon=""
                      ></el-input>
                    </el-col> </el-row
                  ><span style="position: absolute; right: 2px; top: 0">‰</span>
                </div>
              </el-form-item>
            </div>
          </el-form>
          <!-- 运单图片 -->
          <div class="upload_pic" style="margin-bottom: 10px">
            <div
              style="
                margin-bottom: 10px;
                font-size: 13px;
                color: #303133;
                line-height: 1.769230769230769;
              "
            >
              上传图片: (支持上传jpg/png文件)
            </div>
            <my-image-upload
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :disabled="disabledSee || feeCheckIn"
            ></my-image-upload>
          </div>
        </div>
      </div>
      <!-- 财务应收 -->
      <div class="infoDiv">
        <div class="h3title">财务应收</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            :model="financeInInfo"
            ref="form5"
            :rules="baseEdit ? {} : rule5"
          >
            <el-form-item
              label="计费方式:"
              :required="!baseEdit"
              prop="formulaBillingWeightId"
            >
              <el-select
                v-model="financeInInfo.formulaBillingWeightId"
                placeholder="请选择"
                clearable
                filterable
                @change="changeBILLMethode"
                :disabled="disabledSee || baseEdit"
              >
                <el-option
                  v-for="item in formulasBillingWeight"
                  :key="item.formulaBillingWeightId"
                  :label="item.formulaBillingWeightName"
                  :value="item.formulaBillingWeightId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单价:">
              <el-input
                :disabled="disabledSee || baseEdit"
                type="number"
                @mousewheel.native.prevent
                v-model="financeInInfo.unitPrice"
                placeholder="请输入"
                @input="getGoodsTable(0, 0)"
              ></el-input>
            </el-form-item>
            <el-form-item label="基本运费:" prop="basicFreight">
              <div class="disFlexs jsInput">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.basicFreight"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @mousewheel.native.prevent
                  @change="getTotalFreight()"
                ></el-input>
                <!-- <el-button class="jsBtns glo_bgcMainColor"
                           @click="getBasicFreight()">计算</el-button> -->
              </div>
            </el-form-item>
            <el-form-item label="提货费:" prop="takeFee">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.takeFee"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
              ></el-input>
            </el-form-item>
            <el-form-item label="送货费:" prop="sendFee">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.sendFee"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
              ></el-input>
            </el-form-item>
            <el-form-item label="中转费:" prop="transferFee">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.transferFee"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
              ></el-input>
            </el-form-item>
            <el-form-item label="代收货款:" prop="agentAmount">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.agentAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="calcAgentService"
              ></el-input>
            </el-form-item>
            <el-form-item label="贷款手续费:" prop="agentServiceRate">
              <div class="glo_disFlex" style="padding-right: 3px">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  class="miniInput"
                  v-model="financeInInfo.agentServiceRate"
                  placeholder="费率"
                  type="number"
                  @mousewheel.native.prevent
                  @change="calcAgentService"
                ></el-input
                >‰
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.agentServiceFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @mousewheel.native.prevent
                  @change="calcAgentService"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="保险费:" prop="insuranceFee">
              <div class="disFlexs jsInput">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.insuranceFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @mousewheel.native.prevent
                  @change="getTotalFreight()"
                ></el-input>
                <el-button
                  v-if="financeInInfo.isInsure"
                  class="jsBtns glo_bgcMainColor"
                  @click="getBXFee"
                  >计算</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="其他费用:" prop="allOtherFee">
              <div class="disFlexs jsInput">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.allOtherFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @mousewheel.native.prevent
                  @change="getTotalFreight()"
                ></el-input>
                <el-button class="jsBtns glo_bgcMainColor" @click="AddFeiXian"
                  >明细</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              label="服务费:"
              prop="serviceFee"
              :required="!baseEdit"
            >
              <div class="disFlexs jsInput">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.serviceFee"
                  placeholder="自动计算"
                  clearable
                  type="number"
                  @mousewheel.native.prevent
                  @change="getTotalFreight()"
                ></el-input>
                <el-button
                  class="jsBtns glo_bgcMainColor"
                  @click="AddServiceFee"
                  >明细</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              label="运费合计:"
              prop="totalFreight"
              :required="!baseEdit"
            >
              <div class="disFlexs jsInput">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.totalFreight"
                  placeholder="请输入"
                  clearable
                  type="number"
                ></el-input>
                <el-button
                  class="jsBtns glo_bgcMainColor"
                  @click="getTotalFreight()"
                  >计算</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              :required="!baseEdit"
              label="结算方式:"
              prop="settlementMethodConfDictId"
            >
              <el-select
                :disabled="disabledSee || baseEdit"
                filterable
                clearable
                v-model="financeInInfo.settlementMethodConfDictId"
                placeholder="请选择"
                @change="changeSettlementMethod"
              >
                <el-option
                  v-for="item in settlementMethods_1"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="现付金额:" prop="senderAmount">
              <el-input
                :disabled="disabledSee || baseEdit || senderAmountDisable"
                v-model="financeInInfo.senderAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
              ></el-input>
            </el-form-item>
            <el-form-item label="到付金额:" prop="receivedAmount">
              <el-input
                :disabled="disabledSee || baseEdit || receivedAmountDisable"
                v-model="financeInInfo.receivedAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
              ></el-input>
            </el-form-item>
            <el-form-item label="月结金额:" prop="monthlyAmount">
              <el-input
                :disabled="disabledSee || baseEdit || monthlyAmountDisable"
                v-model="financeInInfo.monthlyAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
              ></el-input>
            </el-form-item>
            <el-form-item label="回单付金额:" prop="rnorderAmount">
              <el-input
                :disabled="disabledSee || baseEdit || rnorderAmountDisable"
                v-model="financeInInfo.rnorderAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
              ></el-input>
            </el-form-item>
            <el-form-item label="贷款扣运费:" prop="goodsDeductedAmoun">
              <el-input
                :disabled="disabledSee || baseEdit || goodsDeductedAmounDisable"
                v-model="financeInInfo.goodsDeductedAmoun"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="是否开票:"
              prop="isInvoice"
              :required="!baseEdit"
            >
              <el-switch
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.isInvoice"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
            <el-form-item label="到付月结客户:" prop="receivedCustomerId">
              <el-select
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.receivedCustomerId"
                placeholder="请选择"
                clearable
                filterable
                @change="changeReceivedCustomer"
              >
                <el-option
                  v-for="item in CustomerLists"
                  :key="item.customerId"
                  :label="item.customerName"
                  :value="item.customerId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="textArea"
              style="width: 100%; margin-right: 0"
              label="财务备注:"
              prop="financeRemarks"
            >
              <el-input
                :disabled="disabledSee || baseEdit"
                type="textarea"
                placeholder="请输入"
                rows="2"
                v-model="financeInInfo.financeRemarks"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 应付费用 -->
      <div class="infoDiv">
        <div class="h3title">应付费用</div>
        <div class="formbox goodsItmes">
          <div style="width: 100%; margin-bottom: 10px">
            <el-button
              class="glo_bgcMainColor saveBtnsAddGG"
              @click="addYinFu"
              v-if="feeCheckIn || !waybillSplitId"
              >添加应付</el-button
            >
          </div>
          <div class="glo_Table goodsTable">
            <!-- 货物表格 -->
            <el-table
              :data="financeOutInfos_2"
              border
              ref="feesPayableTable"
              show-summary
              :summary-method="getFeesPaySummaries"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="itemCategoryName"
                label="费项类型"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.itemCategoryName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="itemServiceName"
                label="费项"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.itemServiceName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="amount"
                label="金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.amount }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                show-overflow-tooltip
                align="center"
                prop="urrency"
                label="币种"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.urrency }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="objectStatusTypeName"
                label="结算对象类型"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.objectStatusTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="objectName"
                label="结算对象"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.objectName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="paymentMethod"
                label="付款方式"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.paymentMethod }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="remarks"
                label="备注"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remarks }}</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="140"
                v-if="feeCheckIn || !waybillSplitId"
              >
                <template slot-scope="scope">
                  <div class="iconList">
                    <el-button
                      class="tbBtns"
                      @click="editFeiXian(scope.row, scope.$index)"
                      >编辑</el-button
                    >

                    <el-popconfirm
                      title="确定删除该行费项信息吗"
                      @confirm="delFeiXian(scope.row)"
                    >
                      <el-button slot="reference" class="tbBtns"
                        >删除</el-button
                      >
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 其他信息 -->
      <div class="infoDiv" style="border-bottom: 1px solid #f59a23">
        <div class="h3title">其他信息</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form6"
          >
            <el-form-item label="业务员:" prop="businessId">
              <el-select
                filterable
                clearable
                v-model="otherInfo.businessId"
                placeholder="请选择"
                @change="changeBusinessMan"
                :disabled="disabledSee || feeCheckIn"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.jobNumber"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务员提成:" prop="businessCostRate">
              <div class="glo_disFlex" style="padding-right: 3px">
                <el-input
                  :disabled="disabledSee || feeCheckIn"
                  v-model="otherInfo.businessCostRate"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @mousewheel.native.prevent
                ></el-input>
                %
              </div>
            </el-form-item>
            <el-form-item label="跟单员:" prop="merchandiserEmployeeId">
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="otherInfo.merchandiserEmployeeId"
                placeholder="请选择"
                @change="changeMerchandiserEmployee"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.jobNumber"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="装卸员:" prop="handlingEmployeeId">
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="otherInfo.handlingEmployeeId"
                placeholder="请选择"
                @change="changeHandlingEmployee"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.jobNumber"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录单员:" prop="sendFee">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="financeInInfo.sendFee"
                placeholder="保存自动记录账号"
                readonly
                @mousewheel.native.prevent
              ></el-input>
            </el-form-item>
            <el-form-item label="录单时间:" prop="sendFee">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="financeInInfo.sendFee"
                placeholder="保存自动记录"
                readonly
                @mousewheel.native.prevent
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <myDialog
      :diaWidth="diaWidth1"
      :dialogTitle="dialogTitle1"
      :isShowDialog="isShowDialog1"
      :showCacel="false"
      @handleCloseDia="handleCloseDia1"
      @diaCancelBtn="handleCloseDia1"
      @diaConfirmBtn="diaConfirmBtn1"
    >
      <div class="glo_dialogForm">
        <el-table :data="specifications_1" border style="width: 100%">
          <el-table-column label="*长" prop="length">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].length"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee || feeCheckIn"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*宽" prop="wide">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].wide"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee || feeCheckIn"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*高" prop="height">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].height"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee || feeCheckIn"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*件数" prop="packageCout">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].packageCout"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee || feeCheckIn"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            v-if="!disabledSee && !feeCheckIn"
          >
            <template slot-scope="scope">
              <div class="iconList">
                <i
                  v-if="specifications_1.length == scope.$index + 1"
                  class="el-icon-circle-plus iconSize"
                  @click="clickAdd"
                ></i>
                <el-popconfirm
                  v-if="specifications_1.length > 1"
                  title="确定删除该行规格吗"
                  @confirm="clickDel(scope.$index)"
                >
                  <i slot="reference" class="el-icon-remove iconSize"></i>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </myDialog>
    <!-- 弹窗 添加应收其他费用 -->
    <myDialog
      diaWidth="900px"
      dialogTitle="其他费用"
      :isShowDialog="isShowDialog6"
      @handleCloseDia="handleCloseYingShou"
      @diaCancelBtn="handleCloseYingShou"
      @diaConfirmBtn="handleConfirmYingShouu"
    >
      <div
        class="glo_dialogForm"
        style="display: flex; flex-flow: column; overflow: hidden"
      >
        <el-form
          class="diaForm"
          ref="dialogForm6Ref"
          :model="dialogForm6"
          label-width="100px"
        >
          <div
            style="
              display: flex;
              width: 100%;
              align-item: center;
              justify-content: space-between;
            "
          >
            <el-form-item
              class="dialogFormItems"
              prop="itemCategoryId"
              label="费项与金额:"
              style="flex: 1; margin-bottom: 0px"
            >
              <div class="multipleSelect item-category-container">
                <el-select
                  filterable
                  clearable
                  v-model="dialogForm6.itemCategoryId"
                  placeholder="请选择费项类型"
                  @change="changeItemCategoryIdYF6"
                >
                  <el-option
                    v-for="(item, index) in categoryNameList"
                    :key="index"
                    :label="item.categoryName"
                    :value="item.categoryId"
                  ></el-option>
                </el-select>
                <el-select
                  allow-create
                  filterable
                  clearable
                  v-model="dialogForm6.itemServiceId"
                  placeholder="请选择费项"
                  @change="changeItemServiceId6"
                >
                  <el-option
                    v-for="(item, index) in CategoryServiceList"
                    :key="index"
                    :label="item.title"
                    :value="item.itemServiceId"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="dialogForm6.amount"
                  type="number"
                  placeholder="请输入金额"
                ></el-input>
              </div>
            </el-form-item>
            <el-button
              class="glo_bgcMainColor"
              style="margin-bottom: 0px"
              @click="addOtherFeeInfo"
              >添加费项</el-button
            >
          </div>
        </el-form>
        <div style="flex: 1">
          <el-table :data="otherFeeInfos_1" height="100%">
            <el-table-column
              label="序号"
              prop="index"
              type="index"
            ></el-table-column>
            <el-table-column label="费项类型" prop="itemCategoryName">
              <template #default="{ row }">
                <el-select
                  filterable
                  clearable
                  v-model="row.itemCategoryId"
                  placeholder="请选择费项类型"
                  @change="changeItemCategory(row)"
                >
                  <el-option
                    v-for="(item, index) in categoryNameList"
                    :key="index"
                    :label="item.categoryName"
                    :value="item.categoryId"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="费项" prop="itemServiceName">
              <template #default="{ row }">
                <el-select
                  allow-create
                  filterable
                  clearable
                  v-model="row.itemServiceId"
                  placeholder="请选择费项"
                  @change="changeItemService(row)"
                >
                  <el-option
                    v-for="(item, index) in CategoryServiceList"
                    :key="index"
                    :label="item.title"
                    :value="item.itemServiceId"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="amount">
              <template #default="{ row }">
                <el-input
                  v-model="row.amount"
                  type="number"
                  placeholder="请输入金额"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template #default="{ row }">
                <!-- <el-button plain type="text" @click="changeOtherFeeInfo(row)"
                  >编辑</el-button
                > -->
                <el-button plain type="text" @click="delOtherFeeInfo(row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>
    <!-- 弹窗 服务费用 -->
    <myDialog
      diaWidth="900px"
      dialogTitle="服务费"
      :isShowDialog="isShowDialog7"
      @handleCloseDia="handleCloseService"
      @diaCancelBtn="handleCloseService"
      @diaConfirmBtn="handleCloseService"
    >
      <div
        class="glo_dialogForm"
        style="display: flex; flex-flow: column; overflow: hidden"
      >
        <el-table :data="serviceFees" height="100%" show-summary>
          <el-table-column
            label="序号"
            prop="index"
            type="index"
          ></el-table-column>
          <el-table-column label="费项类型" prop="itemCategoryName">
          </el-table-column>
          <el-table-column label="费项" prop="itemServiceName">
          </el-table-column>
          <el-table-column label="金额" prop="amount"> </el-table-column>
        </el-table>
      </div>
    </myDialog>
    <!-- 弹窗 添加应付 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogForm2Ref')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm2Ref"
          v-if="isShowDialog2"
          :model="dialogForm2"
          label-width="100px"
        >
          <el-form-item
            style="width: 500px"
            class="dialogFormItems"
            prop="objectStatusType"
            label="结算对象:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectStatusConfDictId"
                placeholder="请选择"
                @change="changeObjestStatus"
              >
                <el-option
                  v-for="item in objectStatusList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectName"
                placeholder="请选择"
                :allow-create="dialogForm2.objectStatusType == 'other'"
                remote
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            style="width: 100px"
            class="dialogFormItems"
            prop="paymentMethodConfDictId"
            label="付款方式:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm2.paymentMethodConfDictId"
              placeholder="请选择"
              @change="changePayMent"
            >
              <el-option
                v-for="item in settlementMethods"
                :key="item.id"
                :label="item.val"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="width: 100%">
            <el-form-item
              style="width: 300px"
              class="dialogFormItems"
              prop="preparerEmployeeId"
              label="垫付人:"
            >
              <el-select
                filterable
                clearable
                v-model="dialogForm2.preparerEmployeeId"
                placeholder="请选择"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.jobNumber"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div
            style="display: flex; width: 95%"
            v-for="(financeOutInfo, index) in financeOutInfos_1"
            :key="index"
          >
            <el-form-item
              style="flex: 1"
              :style="index == 0 ? '' : 'margin-left:100px;'"
              class="dialogFormItems"
              prop="itemCategoryId"
              :label="index == 0 ? '费项与金额:' : ''"
              :label-width="index == 0 ? '100px' : '0px'"
            >
              <div class="multipleSelect item-category-container">
                <el-select
                  filterable
                  clearable
                  v-model="dialogForm2.itemCategoryId"
                  placeholder="请选择费项类型"
                  @change="changeItemCategoryIdYF"
                >
                  <el-option
                    v-for="(item, index) in categoryNameList"
                    :key="index"
                    :label="item.categoryName"
                    :value="item.categoryId"
                  ></el-option>
                </el-select>
                <el-select
                  allow-create
                  filterable
                  clearable
                  v-model="dialogForm2.itemServiceId"
                  placeholder="请选择费项"
                  @change="changeItemServiceId2"
                >
                  <el-option
                    v-for="(item, index) in CategoryServiceList"
                    :key="index"
                    :label="item.title"
                    :value="item.itemServiceId"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="dialogForm2.amount"
                  type="number"
                  @mousewheel.native.prevent
                  placeholder="请输入金额"
                ></el-input>
              </div>
            </el-form-item>
            <div
              class="iconList"
              style="
                margin-bottom: 22px;
                width: 80px;
                display: flex;
                justify-content: space-between;
              "
            >
              <el-popconfirm
                v-if="financeOutInfos_1.length > 1"
                title="确定删除该行费项信息吗"
                @confirm="delCategory(index)"
              >
                <i
                  slot="reference"
                  class="el-icon-remove iconSize"
                  style="margin-left: 10px"
                ></i>
              </el-popconfirm>
              <i
                v-if="index == financeOutInfos_1.length - 1"
                class="el-icon-circle-plus iconSize"
                @click="addCategory(index)"
              ></i>
            </div>
          </div>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片">
            <my-image-upload
              @input="changeFileList2"
              :fileNameLists="dialogForm2.files"
              :limit="9"
              :disabled="disabledSee && !feeCheckIn"
            ></my-image-upload>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 弹窗 收件人地址 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      :showConfirm="false"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3"
    >
      <div class="glo_dialogForm" ref="myDialogRef_as">
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            v-if="isShowDialog3"
            :model="queryData"
            class="glo_form"
            label-position="left"
          >
            <el-form-item class="queryItems" label="联系人:">
              <el-input
                clearable
                v-model="queryData.personnelName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="联系电话:">
              <el-input
                clearable
                v-model="queryData.phone"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="单位/仓库:">
              <el-input
                clearable
                v-model="queryData.deptName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="getCustomerAddrList"
              >查询</el-button
            >
          </el-form>
        </div>
        <div class="glo_Table" style="height: 300px; display: flex">
          <el-table
            height="100%"
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            border
            stripe
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column label="操作" min-width="100px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    class="rbtns"
                    @click.stop="changeAddress(scope.row)"
                    >选择</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in addressTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
        <!-- 分页 -->
        <paging
          :pageNum="pageStart_as"
          :total="pageCount_as"
          :size="pageTotal_as"
          @handleSizeChange="handleSizeChange_as"
          @handleCurrentChange="handleCurrentChange_as"
        ></paging>
      </div>
    </myDialog>
    <myDialog
      diaWidth="40%"
      dialogTitle="地址识别"
      :isShowDialog="isShowDialogAI"
      :showConfirm="true"
      @handleCloseDia="handleCloseDiaAI"
      @diaCancelBtn="handleCloseDiaAI"
      @diaConfirmBtn="diaConfirmBtnAI"
    >
      <el-card
        shadow="never"
        style="margin-top: 5px; margin-bottom: 5px; border: none"
        body-style="padding:0;"
      >
        <el-input
          type="textarea"
          class="address-ai-input"
          ref="addressAIInput"
          rows="6"
          v-model="addressAI.addressBefore"
        ></el-input>
        <div class="address-ai-button-container">
          <el-button type="primary" size="mini" @click="clearAddressAIText"
            >清空</el-button
          >
          <el-button type="primary" size="mini" @click="analysisAddress"
            >识别</el-button
          >
        </div>
      </el-card>
      <el-card
        shadow="never"
        style="border: 1px solid #cccccc"
        body-style="padding:8px;"
      >
        <el-form
          label-position="left"
          label-width="90px"
          class="address-ai-form"
        >
          <el-form-item label="姓名：">
            {{ addressAI.username }}
          </el-form-item>
          <el-form-item label="电话：">
            {{ addressAI.phone }}
          </el-form-item>
          <el-form-item label="省市区：">
            {{ addressAI.province }}-{{ addressAI.city }}-{{ addressAI.area }}
          </el-form-item>
          <el-form-item label="详细地址：">
            {{ addressAI.address }}
          </el-form-item>
        </el-form>
      </el-card>
    </myDialog>
    <myDialog
      diaWidth="1100px"
      dialogTitle="选择地址"
      :isShowDialog="isShowDialogMap"
      :dialogFooter="false"
      @handleCloseDia="handleCloseDiaMap"
      @diaCancelBtn="handleCloseDiaMap"
      @diaConfirmBtn="diaConfirmBtnMap"
      class="amp-map-dialog"
    >
      <AMPMAP @choose-it="chooseAddress" v-if="isShowDialogMap"></AMPMAP>
    </myDialog>
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      modelTypeVal="运单打印模板"
      ref="myPrint"
      :dataSource="printDataSource"
    ></my-print>

    <!-- 回车顺序设置 -->
    <myDialog
      :diaWidth="diaWidth_enter"
      :dialogTitle="dialogTitle_enter"
      :isShowDialog="isShowDialog_enter"
      @handleCloseDia="handleCloseDia_enter"
      @diaCancelBtn="handleCloseDia_enter"
      @diaConfirmBtn="diaConfirmBtn_enter('dialogFormRef_enter')"
    >
      <div class="tranfserTb glo_Table">
        <!-- 左边 -->
        <div class="tranfser_item">
          <div class="tranfser_tit">页面所有输入框字段</div>
          <el-table
            ref="tableLeft"
            :data="tableDataLeft"
            border
            :height="tfHeight"
            @row-click="handleRowClick"
            @selection-change="handleSelectionChangeLeft"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="group" label="模块"> </el-table-column>
            <el-table-column prop="label" label="输入框字段"> </el-table-column>
          </el-table>
        </div>
        <div class="tranfser_center" :style="'height:' + tfHeight">
          <el-button class="glo_bgcMainColor btnA" @click="toRight"
            >选定并右移 ></el-button
          >
        </div>
        <!-- 右边 -->
        <div class="tranfser_item">
          <div class="tranfser_tit">需要回车控制的输入框字段</div>
          <div :style="'height:' + tfHeight" class="draggableClass">
            <div class="daraStyle_1 daraStyle_H">
              <div class="daraNum_1">序号</div>
              <div class="cloWidth_1">回车键顺序</div>
              <div class="icon_del">操作</div>
            </div>
            <!-- 可拖拽区域 -->
            <draggable v-model="tableDataRight">
              <transition-group>
                <div
                  class="daraStyle_1"
                  v-for="(element, index) in tableDataRight"
                  :key="element.FileKey"
                >
                  <div class="daraNum_1">{{ index + 1 }}</div>
                  <div class="cloWidth_1">{{ element.label }}</div>
                  <div class="icon_del" @click="delRows(index)">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import MyImageUpload from "@/components/MyImageUpload.vue";
import paging from "@/components/pagings.vue"; //分页组件
import AddressParse from "address-parse";
import AMPMAP from "@/components/AMPMAP.vue";
import MyPrint from "@/components/print/MyPrint.vue";
import draggable from "vuedraggable";
import jsPDF from "jspdf";
export default {
  inject: ["reload"],
  components: {
    myDialog,
    paging,
    MyImageUpload,
    AMPMAP,
    MyPrint,
    draggable,
  },
  props: {
    commandIds: {
      type: String,
      require: false,
      default() {
        return "[]";
      },
    },
    waybillSplitId: {
      type: String,
      require: false,
      default() {
        return null;
      },
    },
    isSee: {},
    type: {
      type: String,
      require: false,
      default: "edit",
    },
  },
  data() {
    return {
      pageStart_as: 1, //  页码
      pageCount_as: 0, //  总条数
      pageTotal_as: this.$COMMON.pageTotals, //
      TBHeight_as: 500,
      saveKeys: "",
      //disabledSee: false,
      loadingDetail: false,
      volumeDivisor: "",
      baseInfo: {
        waybillSplitId: null,
        //	基础信息
        waybillNumber: "",
        transferNumber: "",
        customerOrderNumber: "",
        businessDate: this.$moment().format("YYYY-MM-DD"),
        destCity: "",
        transportLineId: null,
        endDeptId: null,
        receiveMethodConfDictId: null,
        transportMethodConfDictId: null,
        sendMethodConfDictId: null,
        rnRequireConfDictId: null,
        rnRequireName: "",
        rnRequireCount: null,
        commandToWaybillType: 0,
        commandId: null,
        commandIds: [],
        customerType: 0,
        customerId: null,
        customerName: null,
        remarks: null,
        receiveOrderDeptId: this.$TOOLS.getUserInfo().departmentId || null,
      },
      sendAddr: {
        addrId: null,
        serialNumber: 1,
        contacts: "",
        company: "",
        tel: "",
        idNumber: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
        operationType: "UNCHANGED",
      },
      sendAddrs: [
        {
          itemId: null,
          serialNumber: "1",
          goodsNumber: "",
          goodsName: "",
          itemCategoryCode: "",
          itemCategoryName: "",
          packageName: "",
          packageCout: null,
          grossWeight: null,
          netWeight: null,
          volumeWeight: null,
          weightVolume: null,
          billingWeight: null,
          volume: null,
          specs: null,
          volumeDivisor: null,
          heavyCargoConfDictId: null,
          operationType: "UNCHANGED",
          itemSpecss: [
            {
              specsId: null,
              packageCout: null,
              length: null,
              wide: null,
              height: null,
              operationType: "UNCHANGED",
            },
          ],
          CategoryList: [],
        },
      ],
      sendAddrs_1: [],
      receiveAddr: {
        addrId: null,
        serialNumber: "1",
        contacts: "",
        company: "",
        tel: "",
        idNumber: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
      },
      takeAddr: {
        addrId: null,
        serialNumber: "1",
        contacts: "",
        company: "",
        tel: "",
        idNumber: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
      },
      transportInfo: {
        takeTime: null,
        deliveryTime: null,
        isIntoStorage: null,
        intoStorageNumber: null,
        receiveStorageNumber: null,
        specialRequireConfDictId: null,
        isUrgent: 0,
        isValuable: 0,
        isWaitNoticeSend: 0,
        declaredValue: null,
        declaredValueRate: null,
      },
      files: [
        {
          fileId: null,
          fileName: null,
        },
      ],
      otherInfo: {
        businessId: null,
        businessCostRate: null,
        merchandiserEmployeeId: null,
        handlingEmployeeId: null,
      },
      financeInInfo: {
        waybillSplitId: null,
        formulaBillingWeightId: null,
        formulaBillingWeightName: null,
        unitPrice: null,
        basicFreight: null,
        takeFee: null,
        sendFee: null,
        transferFee: null,
        agentAmount: null,
        agentServiceRate: null,
        agentServiceFee: null,
        insuranceFee: null,
        allOtherFee: null,
        serviceFee: null,
        totalFreight: null,
        settlementMethodConfDictId: null,
        senderAmount: null,
        receivedAmount: null,
        monthlyAmount: null,
        rnorderAmount: null,
        goodsDeductedAmoun: null,
        isInvoice: 0,
        receivedCustomerId: null,
        financeRemarks: null,
        isInsure: null,
        declaredValue: null,
        declaredValueRate: null,
        otherFeeInfos: [],
      },
      financeOutInfos: [],
      financeOutInfos_1: [
        {
          id: null,
          itemCategoryId: null,
          itemCategoryName: null,
          itemServiceId: null,
          itemServiceName: null,
          amount: null,
          remarks: null,
          inoutStatus: null,
          objectStatusConfDictId: null,
          objectNumber: null,
          objectName: null,
          paymentMethodConfDictId: null,
          paymentMethod: null,
        },
      ],
      financeOutInfos_2: [],
      formulasBillingWeight: [],
      inoutStatusList: [
        {
          name: "收入",
          val: "shou_ru:deal_status",
        },
        {
          name: "支出",
          val: "zhi_chu:deal_status",
        },
      ],

      isAutoAddr_sj: false,
      isAutoAddr_jj: false,
      SuperiorRegionList: [], //省
      cityNameList: [], //市
      areaNameList: [], //区
      isAutoAddr_sj_1: false,
      cityNameList_1: [], //市
      areaNameList_1: [], //区

      cityNameList_2: [], //市
      areaNameList_2: [], //区

      CustomerLists: [], //客户列表
      addressNaemList: [], //客户档案列表
      OUTsendMethodList: [], //送货方式
      OUTTakeMethodList: [], //外发提货
      packageNameList: [], //货物信息
      car_type_list: [], //车型
      employeeList: [], // 开单接收人
      employeeList_1: [], //调度接收人
      storageList: [], //入仓仓库
      businessDepts: [],
      CarrierDeptListList: [], //网点
      changeCarrierList: [], //外发承运商

      // 目的城市
      destCitys: [],
      destCityLoading: false,
      //线路
      lines: [],
      transportLineLoading: false,
      // 发货方式
      receMethods: [],
      transportMethods: [],
      sendMethods: [],
      rnRequirements: [],
      settlementMethods: [],
      specialRequirements: [],
      heavyCargos: [],
      // 弹窗===添加应付
      isShowDialog2: false,
      dialogTitle2: "",
      dialogType2: "",
      editYfIdx: 0,
      editYfRow: undefined,
      diaWidth2: "900px",
      dialogForm2: {
        // 弹窗表单数据
        amount: null,
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        objectName: null,
        objectNumber: null,
        objectStatusConfDictId: null,
        paymentMethodConfDictId: null,
        remarks: null,
        objectStatusType: null, //对象类型(我自己加的)
        paymentMethod: null, //付款方式名称(我自己加的)
        files: [],
        preparerEmployeeId: this.$TOOLS.getUserInfo().employeeId,
      },

      // 地址弹窗
      isShowDialog3: false,
      isShowDialogAI: false,
      isShowDialogMap: false,
      addressAI: {
        addressType: "",
        addressText: "",
      },
      addressMap: {
        addressType: "",
      },
      dialogTitle3: "",
      diaWidth3: "80%",
      tableData: [],
      addressTableHeard: [
        {
          name: "单位",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系人",
          field: "personnelName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "身份证号",
          field: "idNumber",
          width: "180",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "省份",
          field: "provinceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "城市",
          field: "cityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "区县",
          field: "areaName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "详细地址",
          field: "address",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData: [], //收发地址 表格选择
      queryData: {
        //收发地址 查询条件
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      },

      //弹框 规格尺寸
      specIndex1: 0,
      isShowDialog1: false,
      dialogTitle1: "规格尺寸",
      diaWidth1: "60%",
      specifications: [
        {
          height: "",
          length: null,
          packageCout: null,
          wide: null,
          specsId: null,
          operationType: "UNCHANGED",
        },
      ], //规格尺寸 数据
      specifications_1: [],
      totalArr: [
        "packageCout",
        "grossWeight",
        "netWeight",
        "volume",
        "volumeWeight",
        "weightVolume",
        "billingWeight",
      ], //  表格需要合计的字段
      waybillStatus: "未审核",
      fileNameLists: [],
      rules1: {},
      emps: [],
      // 应付费用表格数据
      feesPayableTableTo: ["total"],
      commands: [],
      objectStatusList: [], //结算对象类型
      CustomerListsYF: [], //对象列表
      categoryNameList: [], //费项类型
      CategoryServiceList: [], //费项
      // 应收费项
      isShowDialog6: false,
      dialogTitle6: "新增应收",
      dialogForm6: {
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        remarks: null,
        amount: null,
      },
      otherFeeInfos: [],
      otherFeeInfos_1: [],
      isShowDialog7: false,
      serviceFees: [
        {
          itemCategoryName: "服务费",
          itemServiceName: "开单服务费",
          amount: 1,
          sort: 1,
        },
      ],
      serviceFees_1: this.serviceFees,
      senderAmountDisable: true,
      receivedAmountDisable: true,
      rnorderAmountDisable: true,
      monthlyAmountDisable: true,
      goodsDeductedAmounDisable: true,
      rule1: {
        businessDate: [
          {
            required: true,
            message: "业务日期不能为空",
            trigger: "change",
          },
        ],
        receiveOrderDeptId: [
          {
            required: true,
            message: "开单网点不能为空",
            trigger: "change",
          },
        ],
      },
      // 基本信息校验规则
      rule2: {
        destCity: [
          {
            required: true,
            message: "目的城市不能为空",
            trigger: "change",
          },
        ],
        transportLineId: [
          {
            required: true,
            message: "线路不能为空",
            trigger: "change",
          },
        ],
        endDeptId: [
          {
            required: true,
            message: "终端网点不能为空",
            trigger: "change",
          },
        ],
        receiveMethodConfDictId: [
          {
            required: true,
            message: "发货方式不能为空",
            trigger: "change",
          },
        ],
        transportMethodConfDictId: [
          {
            required: true,
            message: "运输方式不能为空",
            trigger: "change",
          },
        ],
        sendMethodConfDictId: [
          {
            required: true,
            message: "交货方式不能为空",
            trigger: "change",
          },
        ],
        rnRequireCount: [
          {
            validator: (rule, value, callback) => {
              if (this.baseInfo.rnRequireConfDictId) {
                if (!value) {
                  callback(new Error("回单份数不能为空"));
                }
              }
              callback();
            },
            trigger: "chagne",
          },
        ],
      },
      rule4: {},
      rule5: {
        formulaBillingWeightId: [
          {
            required: true,
            message: "计费方式不能为空",
            trigger: "change",
          },
        ],
        serviceFee: [
          {
            required: true,
            message: "服务费不能为空",
            trigger: "change",
          },
        ],
        totalFreight: [
          {
            required: true,
            message: "运费合计不能为空",
            trigger: "change",
          },
        ],
        settlementMethodConfDictId: [
          {
            required: true,
            message: "结算方式不能为空",
            trigger: "change",
          },
        ],
        isInvoice: [
          {
            required: true,
            message: "是否开票不能为空",
            trigger: "change",
          },
        ],
        receivedCustomerId: [
          {
            validator: (rule, value, callback) => {
              if (this.financeInInfo.settlementMethodConfDictId) {
                let val;
                this.settlementMethods.forEach((item) => {
                  if (
                    item.id == this.financeInInfo.settlementMethodConfDictId
                  ) {
                    val = item.key;
                  }
                });
                if (val === "ji_fu_yue_jie") {
                  if (!value) {
                    callback(new Error("到付月结客户不能为空"));
                  }
                }
              }
              callback();
            },
            trigger: "chagne",
          },
        ],
      },
      rule7: {
        customerId: [
          {
            validator: (rule, value, callback) => {
              if (this.baseInfo.customerType) {
                if (!value) {
                  callback(new Error("客户不能为空"));
                }
              }
              callback();
            },
            trigger: "chagne",
          },
        ],
      },
      rule8: {
        isInsure: [
          {
            required: true,
            message: "是否投保不能为空",
            trigger: "change",
          },
        ],
        declaredValue: [
          {
            validator: (rule, value, callback) => {
              if (this.financeInInfo.isInsure === 1) {
                if (!value) {
                  callback(new Error("必须填写声明价值"));
                }
              }
              callback();
            },
            trigger: "change",
          },
        ],
      },
      settlementMethods_1: this.settlementMethods || [],
      goodsList: [],
      classNameArr: [
        {
          name: "全打",
          val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillQdPrintDataV5VO",
        },
        {
          name: "套打",
          val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillTdPrintDataV5VO",
        },
        {
          name: "标签打印",
          val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillBqPrintDataV5VO",
        },
        {
          name: "回扣打印",
          val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillHkPrintDataV5VO",
        },
        {
          name: "信封打印",
          val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillXfPrintDataV5VO",
        },
      ], // 默认的模板类型
      modelClassName:
        "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillTdPrintDataV5VO",

      // 弹窗===回车设置
      isShowDialog_enter: false,
      dialogTitle_enter: "运单界面光标设置配置",
      diaWidth_enter: "70%",
      tfHeight: "60vh",
      tableDataLeft: [
        {
          group: "页头", //所在分组
          label: "运单号", //输入框标题
          field: "waybillNumber", //字段名
          FileKey: "k1", //唯一值
          sort: 1, //排序
          isShow: true, //是否展示
        },
        {
          group: "页头",
          label: "中转单号",
          field: "transferNumber",
          FileKey: "k2",
          sort: 2,
          isShow: true,
        },
        {
          group: "页头",
          label: "客户单号",
          field: "customerOrderNumber",
          FileKey: "k3",
          sort: 3,
          isShow: true,
        },
        {
          group: "页头",
          label: "业务日期",
          field: "businessDate",
          FileKey: "k4",
          sort: 4,
          isShow: true,
        },
        {
          group: "页头",
          label: "开单网点",
          field: "receiveOrderDeptId",
          FileKey: "k5",
          sort: 5,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "目的城市",
          field: "destCity",
          FileKey: "k6",
          sort: 6,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "运输路线",
          field: "transportLineId",
          FileKey: "k7",
          sort: 7,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "终端网点",
          field: "endDeptId",
          FileKey: "k8",
          sort: 8,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "发货方式",
          field: "receiveMethodConfDictId",
          FileKey: "k9",
          sort: 9,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "运输方式",
          field: "transportMethodConfDictId",
          FileKey: "k10",
          sort: 10,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "交货方式",
          field: "sendMethodConfDictId",
          FileKey: "k11",
          sort: 11,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "回单要求",
          field: "rnRequireConfDictId",
          FileKey: "k12",
          sort: 12,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "回单要求份数",
          field: "rnRequireCount",
          FileKey: "k13",
          sort: 13,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "订单指令",
          field: "commandId",
          FileKey: "k14",
          sort: 14,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "备注",
          field: "remarks",
          FileKey: "k15",
          sort: 15,
          isShow: true,
        },

        // {
        //   group: "aaaa",
        //   label: "bbb",
        //   field: "cccc",
        //   FileKey: "kdd",
        //   sort: 1,
        //   isShow: true,
        // },
      ],
      tableDataRight: [],
      selectTableDataLeft: [],
      pageEnterSortList: [], //设置好的排序
    };
  },
  watch: {
    serviceFees: {
      deep: true,
      immediate: true,
      handler(val) {
        this.getService();
      },
    },
  },
  created() {
    this.sendAddrs_1 = this.sendAddrs.filter(
      (item) => item.operationType != "DEL"
    );
    this.specifications_1 = this.specifications.filter(
      (item) => item.operationType != "DEL"
    );
  },
  computed: {
    editable() {
      return this.isSee != 1;
    },
    disabledSee() {
      return !this.editable;
    },
    feeCheckIn() {
      return this.type === "feeCheckIn";
    },
    baseEdit() {
      return this.type === "baseEdit";
    },
  },
  mounted() {
    // 根据字典类型获取字典值下拉列表
    this.getConfDictValDownList("package_name", "packageNameList"); //获取包装
    this.getConfDictValDownList(
      "receive_method",
      "receMethods",
      "receiveMethodConfDictId"
    );
    this.getConfDictValDownList(
      "transport_method",
      "transportMethods",
      "transportMethodConfDictId"
    );
    this.getConfDictValDownList(
      "send_method",
      "sendMethods",
      "sendMethodConfDictId"
    );
    this.getConfDictValDownList("rn_order_require", "rnRequirements");
    this.getConfDictValDownList("settlement_method", "settlementMethods");
    this.getConfDictValDownList("special_order_require", "specialRequirements");
    this.getConfDictValDownList("heavy_cargo", "heavyCargos");
    //发货方式

    // 获取接单网点
    this.getBusinessDepts();
    this.getDestCities();
    // 获取线路
    this.getTransportLine();

    // 城市信息
    this.getProvince();
    //this.getCityName();
    //this.getAreaName();
    this.remoteMethodCustomer();
    this.getFormulasBillingWeight();
    this.getCommands();
    // 员工
    this.getEmps();
    this.wtl_getItemList();

    this.$nextTick(() => {
      let pageEnterSort = window.localStorage.getItem("pageEnterSort") || "";
      if (pageEnterSort && pageEnterSort.length > 0) {
        pageEnterSort = JSON.parse(pageEnterSort);
        console.log("pageEnterSort", pageEnterSort);
        this.pageEnterSortList = pageEnterSort;
      }
      let refval =
        this.pageEnterSortList.length > 0
          ? this.pageEnterSortList[0].FileKey
          : "k1";

      this.$refs[refval].focus();
    });
  },
  activated() {
    if (
      this.waybillSplitId &&
      this.baseInfo.waybillSplitId != this.waybillSplitId
    ) {
      this.getWaybillDetail();
      return;
    }
    if (this.commandIds) {
      if (!this.baseInfo.commandIds || this.baseInfo.commandIds.length == 0) {
        const commandIds = JSON.parse(this.commandIds);
        if (commandIds.length > 0) {
          this.baseInfo.commandIds = commandIds;
          this.baseInfo.commandId = commandIds[0];
          this.transformWaybillFromCommands();
        }
      }
      return;
    }
  },
  destroyed() {},

  methods: {
    // ========================= 设置回车顺序弹窗 start =========================
    diaConfirmBtn_enter() {
      if (this.tableDataRight.length == 0) {
        this.$message.error("请设置回车控制的字段").showClose = true;
        return false;
      }
      let rightList = JSON.parse(JSON.stringify(this.tableDataRight)) || [];
      rightList.forEach((element, idx) => {
        element.sort = idx;
      });
      this.tableDataRight = rightList;
      window.localStorage.setItem(
        "pageEnterSort",
        JSON.stringify(this.tableDataRight)
      );
      this.$message.success("设置成功,刷新页面后生效").showClose = true;
      this.handleCloseDia_enter();
    },
    handleCloseDia_enter() {
      this.isShowDialog_enter = false;
    },
    // 点击设置按钮,弹窗
    setEnter() {
      this.isShowDialog_enter = true;
      this.tableDataRight = this.pageEnterSortList;
    },
    // 移除回车控制的字段
    delRows(idx) {
      this.$confirm("是否删除当前行?", "系统提示")
        .then((res) => {
          console.log(res);
          let listA = JSON.parse(JSON.stringify(this.tableDataRight)) || [];
          listA.splice(idx, 1);
          this.tableDataRight = listA;
        })
        .catch(() => {});
    },

    // 点击当前行选中数据
    handleRowClick(row, column, event) {
      // 清除所有选中项
      // this.$refs.tableLeft.clearSelection();
      // 选中当前行
      this.$refs.tableLeft.toggleRowSelection(row, true);
    },

    //
    handleSelectionChangeLeft(e) {
      this.selectTableDataLeft = e;
    },
    // 右移
    toRight() {
      // tableDataLeft
      // tableDataRight
      let listA = this.selectTableDataLeft || [];
      if (listA.length < 1) {
        this.$message.error("请选择左边表格的数据").showClose = true;
        return false;
      }
      let rigthList = JSON.parse(JSON.stringify(this.tableDataRight)) || [];
      let newList = [...rigthList];
      listA.forEach((item2) => {
        // 检查item2是否已存在于newList数组中
        const AA = rigthList.find(
          (itemA) => itemA["FileKey"] === item2["FileKey"]
        );
        if (!AA) {
          newList.push(item2);
        }
      });

      this.tableDataRight = newList;
      this.$message.success("添加成功,已自动过滤重复项").showClose = true;

      // 清除所有选中项
      this.$refs.tableLeft.clearSelection();
    },
    // 选择时间
    changeTimes(e, key, type) {
      this.enterFns("", key, type);
    },
    // 输入框回车
    enterFns(val, key, type) {
      if (type === "select" && !val) {
        // 选择框 没有内容的时候不要跳转下一步
        // this.$message.error("还没有选择内容哦").showClose = true;
        return false;
      }
      console.log("type", type);
      console.log("key", key);

      let refKey = "";
      if (this.pageEnterSortList.length > 0) {
        this.pageEnterSortList.forEach((item, idx) => {
          if (item.FileKey === key) {
            if (idx < this.pageEnterSortList.length - 1) {
              refKey = this.pageEnterSortList[idx + 1].FileKey;
              console.log("refKey", refKey);
              this.$refs[refKey].focus();
              return false;
            } else {
              console.log("idx", idx);
              //最后一个回车
              // 触发保存按钮
              this.submit();
            }
          }
        });
      }
    },

    // ========================= 设置回车顺序弹窗 end =========================

    // 获取物品品类
    wtl_getItemList(categoryName) {
      this.$API.goods().then((res) => {
        this.goodsList = res || [];
      });
    },
    getService() {
      let serviceFee = 0;
      this.serviceFees.map((item) => (serviceFee += parseFloat(item.amount)));
      this.financeInInfo.serviceFee = serviceFee > 9 ? 9 : serviceFee;
      return this.financeInInfo.serviceFee;
    },
    async getCommands() {
      this.commands = await this.$API.runList({
        number: "admin_command_list_v5",
      });
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.dialogForm2.objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogForm2.objectNumber = item.number;
            // this.dialogForm2.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },
    //选择费项(应付弹窗)
    changeItemService(row) {
      if (row.itemServiceId) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == row.itemServiceId) {
            row.amount = item.unitPrice;
            row.itemServiceName = item.title;
          }
        });
      } else {
        row.amount = null;
        row.itemServiceName = null;
      }
    },
    //选择费项(应付弹窗)
    changeItemServiceId2(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm2.amount = item.unitPrice;
            this.dialogForm2.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm2.amount = null;
        this.dialogForm2.itemServiceName = null;
      }
    },
    changeItemServiceId6(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm6.amount = parseFloat(item.unitPrice);
            this.dialogForm6.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm6.amount = null;
        this.dialogForm6.itemServiceName = null;
      }
    },
    changeItemCategory(row) {
      if (row.itemCategoryId) {
        this.wtl_itemServiceListAll(row.itemCategoryId, "fu:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == row.itemCategoryId) {
            row.itemCategoryName = item.categoryName;
          }
        });
      } else {
        row.itemServiceId = null;
        row.amount = null;
        row.itemServiceName = null;
      }
    },
    //选择费项类型(应付)
    changeItemCategoryIdYF(e) {
      if (e) {
        this.wtl_itemServiceListAll(e, "fu:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm2.itemCategoryName = item.categoryName;
          }
        });
      } else {
        this.dialogForm2.itemServiceId = null;
        this.dialogForm2.amount = null;
        this.dialogForm2.itemServiceName = null;
      }
    },
    changeItemCategoryIdYF6(e) {
      if (e) {
        this.wtl_itemServiceListAll(e, "fu:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm6.itemCategoryName = item.categoryName;
          }
        });
      } else {
        this.dialogForm6.itemServiceId = null;
        this.dialogForm6.amount = null;
        this.dialogForm6.itemServiceName = null;
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e, directionStatus) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || null,
          directionStatus: directionStatus || null,
        })
        .then((res) => {
          this.CategoryServiceList = res.data.result || [];
        });
    },
    //选择付款方式(应付弹窗)
    changePayMent(e) {
      if (e) {
        this.settlementMethods.forEach((item) => {
          if (item.id == e) {
            this.dialogForm2.paymentMethod = item.val;
          }
        });
      } else {
        this.dialogForm2.amount = null;
        this.dialogForm2.itemServiceName = null;
      }
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    // 选择图片
    changeFileList2(array) {
      this.dialogForm2.files = array;
    },
    handleSizeChange_as(val) {
      //  分页
      this.pageTotal_as = val;
      this.getCustomerAddrList();
    },
    handleCurrentChange_as(val) {
      //  分页
      this.pageStart_as = val;
      this.getCustomerAddrList();
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.add(prev, curr);
                  // return this.$TOOLS.mathToFixed(
                  //   this.$TOOLS.add(prev, curr),
                  //   2
                  // );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += null;
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable1.doLayout();
      });
      return sums;
    },

    async getEmps() {
      const res = await this.$API.runList({
        number: "down_list_employee",
      });
      this.emps = res;
    },

    // 接口获取详情
    async getWaybillDetail() {
      //this.loadingDetail = true
      const res = await this.$API.getWaybillDetail(this.waybillSplitId);
      this.baseInfo = res.baseInfo || {};
      this.financeInfo = res.financeInfo || {};
      this.receiveAddr = res.receiveAddr || {};
      this.waybillStatus = this.baseInfo.examineStatusShow;
      if (res.sendAddrs) {
        this.sendAddr = {
          ...res.sendAddrs[0],
          operationType: "UNCHANGED",
        };
        this.sendAddrs = res.sendAddrs[0].items;
        this.sendAddrs.forEach((item) => {
          item.operationType = "UNCHANGED";
          if (item.itemSpecss) {
            item.itemSpecss.forEach((spec) => {
              spec.operationType = "UNCHANGED";
            });
            item.CategoryList = [];
          }
        });
        this.sendAddrs_1 = this.sendAddrs.filter(
          (item) => item.operationType != "DEL"
        );
      } else {
        this.sendAddr = {};
        this.sendAddrs = [];
      }
      //this.sendAddrs = res.sendAddrs
      this.takeAddr = res.takeAddr || {};
      this.takeAddr.operationType = "UNCHANGED";
      this.transportInfo = res.transportInfo || {};
      this.fileNameLists = res.files || [];
      this.financeInInfo = res.financeInInfo || {
        waybillSplitId: null,
        formulaBillingWeightId: null,
        formulaBillingWeightName: null,
        unitPrice: null,
        basicFreight: null,
        takeFee: null,
        sendFee: null,
        transferFee: null,
        agentAmount: null,
        agentServiceRate: null,
        agentServiceFee: null,
        insuranceFee: null,
        allOtherFee: null,
        serviceFee: 1,
        totalFreight: 1,
        settlementMethodConfDictId: null,
        senderAmount: null,
        receivedAmount: null,
        monthlyAmount: null,
        rnorderAmount: null,
        goodsDeductedAmoun: null,
        isInvoice: 0,
        receivedCustomerId: null,
        financeRemarks: null,
        isInsure: 0,
        declaredValue: null,
        declaredValueRate: null,
        otherFeeInfos: [],
      };
      this.financeInInfo.isInvoice = this.financeInInfo.isInvoice || 0;
      this.financeOutInfos = res.financeOutInfos || [];
      this.financeOutInfos.map(
        (item) =>
          (item.objectStatusConfDictId = parseInt(item.objectStatusConfDictId))
      );
      this.financeOutInfos_2 = this.financeOutInfos;
      this.otherInfo = res.otherInfo || {};
      //this.loadingDetail = false
      if (this.type == "copy") {
        this.baseInfo.id = null;
        this.baseInfo.waybillNumber = null;
        this.baseInfo.number = null;
      }
      this.financeInInfo.totalFreight = 0;
      // 基本服务费
      if (!this.financeInInfo.serviceFee) {
        this.financeInInfo.serviceFee = 1;
      }
      if (this.baseInfo.rnRequireConfDictId) {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "回单费",
          amount: 1,
          sort: 2,
        });
      }
      if (this.transportInfo.isIntoStorage) {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "入仓费",
          amount: 9,
          sort: 3,
        });
      }
      this.changeCustomerType(false);
      // 触发结算方式修改
      this.changeSettlementMethod();
    },

    async transformWaybillFromCommands() {
      const res = await this.$API.getCommandDetail(this.baseInfo.commandIds[0]);
      this.baseInfo = res.commandInfo || {};
      this.baseInfo.commandToWaybillType =
        this.type === "transferFromCommandPart" ? 0 : 1;
      this.baseInfo.businessDate =
        this.baseInfo.businessDate || this.$moment().format("YYYY-MM-DD");
      this.financeInfo = res.financeInfo || {};
      this.receiveAddr = res.receiveAddr || {};
      if (res.sendAddrs) {
        this.sendAddr = {
          ...res.sendAddrs[0],
          operationType: "UNCHANGED",
        };
        this.sendAddrs = res.sendAddrs[0].itemReqs;
        this.sendAddrs.forEach((item) => {
          item.operationType = "UNCHANGED";
          if (item.itemSpecsReqs) {
            item.itemSpecsReqs.forEach((spec) => {
              spec.operationType = "UNCHANGED";
            });
            item.itemSpecss = item.itemSpecsReqs;
            item.CategoryList = [];
          }
        });
        this.sendAddrs_1 = this.sendAddrs.filter(
          (item) => item.operationType != "DEL"
        );
      } else {
        this.sendAddr = {};
        this.sendAddrs = [];
      }
      //this.sendAddrs = res.sendAddrs
      this.takeAddr = res.takeAddr || {};
      this.takeAddr.operationType = "UNCHANGED";
      const transportInfo = res.transportInfo || {};
      if (res.files) {
        res.files.forEach((item) => {
          this.fileNameLists.push({
            name: item.fileId,
            url: item.fileUrl,
          });
        });
      }
      this.financeInInfo = res.financeInfo || {};
      this.financeInInfo = {
        ...this.financeInInfo,
        isInsure: transportInfo.isInsure || 0,
        declaredValue: transportInfo.declaredValue || 0,
        declaredValueRate: transportInfo.declaredValueRate || 0,
      };
      this.transportInfo = transportInfo;
      this.financeOutInfos = res.financeOutInfos || [];
      this.financeOutInfos.map(
        (item) =>
          (item.objectStatusConfDictId = parseInt(item.objectStatusConfDictId))
      );
      this.financeOutInfos_2 = this.financeOutInfos;
      this.otherInfo = res.otherInfo || {};
      let totalFreight = 0;
      // 基本服务费
      if (!this.financeInInfo.serviceFee) {
        this.financeInInfo.serviceFee = 1;
        totalFreight = 1;
      }
      if (this.baseInfo.rnRequireConfDictId) {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "回单费",
          amount: 1,
          sort: 2,
        });
        totalFreight += 1;
      }
      if (this.transportInfo.isIntoStorage) {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "入仓费",
          amount: 9,
          sort: 3,
        });
      }
      this.financeInInfo.totalFreight =
        this.financeInInfo.totalFreight || totalFreight;
      this.financeInInfo.isInvoice = this.financeInInfo.isInvoice || 0;
      this.changeCustomerType(false);
      // 触发结算方式修改
      this.changeSettlementMethod();
    },

    runPageReportDetailsitemId(conditonVal, i) {
      this.$API
        .runPageReportDetails({
          conditionReqs: [
            {
              conditonKey: "itemId",
              conditonVal,
            },
          ],
          number: "command_item_specs_list",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result.datas || [];
            datas.forEach((n, i) => {
              n.operationType = "UNCHANGED";
            });
            this.takeAddr[i].itemSpecss = datas;
          } else {
            this.$message.error(`${res.data.message}`).showClose = true;
          }
        });
    },

    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    //员工、部门、外发网点
    changeMethod(e, arrs, keys) {
      let curs = this[arrs].filter((item) => item.documentId == e);
      if (keys == "intoDeptName") {
        this.rukuPlanReq[keys] = (curs.length && curs[0].name) || "";
      } else {
        this.baseInfo[keys] = (curs.length && curs[0].name) || "";
      }
    },
    changeSpecialRequire() {
      const selectedSpecialRequirements = this.specialRequirements.filter(
        (item) => item.val === this.transportInfo.specialRequire
      );
      if (selectedSpecialRequirements.length > 0) {
        this.transportInfo.specialRequireConfDictId =
          selectedSpecialRequirements[0].id;
      }
    },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
          console.log(this[keys]);
        });
    },

    //外发承运商
    focusMethodCarrier() {
      if (this.changeCarrierList.length == 0) {
        this.remoteMethodCarrier("");
      }
    },
    //外发承运商
    changeMethodCarrier(e) {
      let curs = this.changeCarrierList.filter((item) => item.carrierId == e);
      this.financeInfo.carrierName = (curs.length && curs[0].carrierName) || "";
      if (e) {
        // 获取承运商——网点
        this.$COMAPI.CarrierDeptList(e).then((res) => {
          this.CarrierDeptListList = res || [];
        });
      }
    },
    //外发承运商 carrierId carrierName
    remoteMethodCarrier(carrierName) {
      this.$API
        .CarrierList({
          carrierName,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.changeCarrierList = res.data.result.data || [];
        });
    },

    //品类
    focusMethodCategory(index) {
      // if (this.sendAddrs[index].CategoryList.length == 0) {
      //   this.remoteMethodCategory("", index);
      // }
    },
    //品类
    changeMethodCategory(e, index) {
      this.sendAddrs_1[index].operationType = "UPDATE";
      if (this.sendAddrs_1[index].CategoryList) {
        let curs = this.sendAddrs_1[index].CategoryList.filter(
          (item) => item.itemCategoryName == e
        );
        this.sendAddrs_1[index].itemCategoryName = e;
        this.sendAddrs_1[index].itemCategoryCode =
          (curs.length && curs[0].itemCategoryCode) || "";
      }
    },
    //品类
    remoteMethodCategory(categoryName, index) {
      this.$API
        .wtl_getCategoryList({
          categoryName,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.sendAddrs_1[index].CategoryList = res.data.result.data || [];
        });
    },

    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    async getConfDictValDownList(dictType, field, realFileName) {
      const res = await this.$API.wtl_getConfDictValDownListV5(dictType);
      let arrs = res || [];
      // 其他情况
      this[field] = arrs;
      if (realFileName && arrs.length > 0) {
        this.baseInfo[realFileName] = arrs[0].id;
      }
      if (this.baseInfo.customerType == 0) {
        this.settlementMethods
          .filter((item) => item.key === "ji_fu_yue_jie")
          .map((item) => (item.disabled = true));
      }
      this.settlementMethods_1 = this.settlementMethods.filter(
        (item) => !(item.disabled == true)
      );
    },

    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },

    //货物信息 添加一行货物信息
    AddGoods(idx) {
      // 最大序号
      const serialNumber = Math.max(
        this.sendAddrs.map((item) =>
          item.serialNumber ? parseInt(item.serialNumber) : 0
        )
      );
      let objs = {
        itemId: null,
        serialNumber: serialNumber,
        goodsNumber: null,
        goodsName: null,
        itemCategoryCode: null,
        itemCategoryName: null,
        packageName: null,
        packageCout: null,
        grossWeight: null,
        netWeight: null,
        volumeWeight: null,
        weightVolume: null,
        billingWeight: null,
        volumeDivisor: this.volumeDivisor,
        volume: null,
        specs: null,
        heavyCargoConfDictId: null,
        operationType: "ADD",
        itemSpecss: [
          {
            specsId: null,
            packageCout: null,
            length: null,
            wide: null,
            height: null,
            operationType: "ADD",
          },
        ],
        CategoryList: [],
      };
      if (this.saveKeys == 2 && this.commandId) {
        objs.operationType = "ADD";
      }
      this.sendAddrs.push(objs);
      this.sendAddrs_1 = this.sendAddrs.filter(
        (item) => item.operationType != "DEL"
      );
    },
    //货物信息 删除一行货物信息
    delGoods(idx) {
      this.sendAddrs_1[idx].operationType = "DEL";
      this.sendAddrs_1 = this.sendAddrs.filter(
        (item) => item.operationType != "DEL"
      );
    },
    onInputHW(index) {
      this.sendAddrs_1[index].operationType = "UPDATE";
    },
    //设置规格
    clickSet(index) {
      this.specIndex1 = index;
      this.sendAddrs[index].operationType = "UPDATE";
      this.specifications = this.sendAddrs[index].itemSpecss || [];
      this.specifications_1 = this.specifications.filter(
        (item) => item.operationType != "DEL"
      );
      this.isShowDialog1 = true;
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
    },
    //设置规格  确认保存
    diaConfirmBtn1() {
      this.sendAddrs[this.specIndex1].itemSpecss = this.specifications;
      this.isShowDialog1 = false;
    },

    //设置规格 添加规格
    clickAdd() {
      this.specifications.push({
        specsId: null,
        height: null,
        length: null,
        packageCout: null,
        wide: null,
        operationType: "ADD",
      });
      this.specifications_1 = this.specifications.filter(
        (item) => item.operationType != "DEL"
      );
    },
    //设置规格 删除一行规格
    clickDel(index) {
      this.specifications_1[index].operationType = "DEL";
      this.specifications_1 = this.specifications.filter(
        (item) => item.operationType != "DEL"
      );
    },
    onInput(index) {
      this.specifications_1[index].operationType = "UPDATE";
    },

    //客户
    async remoteMethodCustomer(customerName) {
      const res = await this.$API.runList({
        customerName,
        pageStart: 1,
        pageTotal: 20,
        approveStatus: "tong_guo:approve_status",
        number: "customer_down_list",
      });
      this.CustomerLists = res || [];
    },
    changeCustomerType(clearSettlement = true) {
      if (this.baseInfo.customerType == 0) {
        this.baseInfo.customerId = null;
        this.baseInfo.customerName = null;
        // 普通客户不能选择月结
        if (clearSettlement) {
          this.financeInInfo.settlementMethodConfDictId = null;
        }
        this.changeSettlementMethod();
        this.settlementMethods
          .filter((item) => item.key === "ji_fu_yue_jie")
          .map((item) => (item.disabled = true));
      } else {
        this.settlementMethods
          .filter((item) => item.key === "ji_fu_yue_jie")
          .map((item) => (item.disabled = false));
      }
      this.settlementMethods_1 = this.settlementMethods.filter(
        (item) => !(item.disabled == true)
      );
    },
    //客户
    focusMethodCustomer() {
      if (this.CustomerLists.length == 0) {
        this.remoteMethodCustomer("");
      }
    },
    //客户  选择或者清除客户时触发
    changeMethodCustomer(e) {
      let curs = this.CustomerLists.filter((item) => item.customerId == e);
      let customerName = (curs.length && curs[0].customerName) || null;
      this.baseInfo.customerName = customerName;
      if (e) {
        this.getCustomerDefaultAddrList(e);
        // 设置结算方式
        const cur = curs[0];
        this.financeInInfo.settlementMethodConfDictId = parseInt(
          cur.settlementMethodConfDictId
        );
        this.financeInInfo.isInvoice = cur.isInvoicing;
        this.financeInInfo.isInsure = cur.isSure;
        this.financeInInfo.declaredValueRate = cur.insuranceRate;
        this.otherInfo.businessId = parseInt(cur.salemanId);
      }
    },
    //客户 根据客户id获取客户默认地址
    getCustomerDefaultAddrList(id) {
      this.$API
        .runList({
          customerId: id,
          number: "customer_default_address_map",
        })
        .then((res) => {
          let datas = res || [];
          if (datas.length > 0) {
            let jjAddressData = {}; // 寄件默认地址;
            let sjAddressData = {}; // 收件默认地址;
            datas.forEach((item) => {
              if (item.addressType == "ji_jian:address_type") {
                jjAddressData = item;
              }
              if (item.addressType == "shou_jian:address_type") {
                sjAddressData = item;
              }
            });
            if (jjAddressData) {
              jjAddressData.contacts = jjAddressData.contactsName;
              jjAddressData.company =
                jjAddressData.companyName || jjAddressData.deptName;
              jjAddressData.tel = jjAddressData.tel || jjAddressData.phone;
              jjAddressData.addrId = null;
              this.sendAddr = JSON.parse(JSON.stringify(jjAddressData));
            } else {
              this.sendAddr = {};
            }
            if (sjAddressData) {
              sjAddressData.contacts = sjAddressData.contactsName || null;
              sjAddressData.company =
                sjAddressData.companyName || sjAddressData.deptName;
              sjAddressData.tel = sjAddressData.tel || sjAddressData.phone;
              sjAddressData.addrId = null;
              this.receiveAddr = JSON.parse(JSON.stringify(sjAddressData));
            } else {
              this.receiveAddr = {};
            }
          } else {
            this.sendAddr = {};
            this.receiveAddr = {};
          }
        });
    },

    // 发货地址 自动识别地址
    geocode(getAddress, getcity) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: getcity || "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let sj = JSON.parse(JSON.stringify(this.sendAddrs));
        sj.provinceName = datas.province;
        sj.cityName = datas.city;
        sj.areaName = datas.district;
        this.sendAddrs = sj;
      });
    },
    // 收货地址 自动识别地址
    geocode_1(getAddress, getcity) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: getcity || "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let sj = JSON.parse(JSON.stringify(this.receiveAddr));
        sj.provinceName = datas.province;
        sj.cityName = datas.city;
        sj.areaName = datas.district;
        this.receiveAddr = sj;
      });
    },
    async getDestCities(keyword) {
      this.destCityLoading = true;
      const data = await this.$API.runList({
        number: "admin_dest_city_downlist",
        keyword,
      });
      this.destCitys = data;
      this.destCityLoading = false;
    },
    async clearDestCity() {
      this.getDestCities();
    },
    changeDestCity(e, refKey) {
      this.getTransportLine();

      this.enterFns(e, refKey, "select");
    },
    async getTransportLine() {
      this.transportLineLoading = true;
      const data = await this.$API.runList({
        number: "down_list_transport_line_v4",
        city: this.baseInfo.destCity,
      });
      this.lines = data;
      this.transportLineLoading = false;
      if (this.lines.length > 0 && this.baseInfo.destCity) {
        this.baseInfo.transportLineId = this.lines[0].id;
        this.volumeDivisor = this.lines[0].volumeDivisor;
        this.baseInfo.endDeptId = this.lines[0].arriveDeptId;
        this.changeEndDept();
        if (this.sendAddrs.length > 0) {
          for (let sendAddr of this.sendAddrs) {
            if (!sendAddr.volumeDivisor) {
              sendAddr.volumeDivisor = this.volumeDivisor;
            }
          }
        }
      }
    },
    changeTransportLine(e, refKey) {
      if (!e) {
        return;
      }
      const line = this.lines.filter(
        (d) => d.id == this.baseInfo.transportLineId
      )[0];
      this.volumeDivisor = line.volumeDivisor;
      this.baseInfo.endDeptId = line.arriveDeptId;
      this.changeEndDept();
      if (this.sendAddrs.length > 0) {
        for (let sendAddr of this.sendAddrs) {
          if (!sendAddr.volumeDivisor) {
            sendAddr.volumeDivisor = this.volumeDivisor;
          }
        }
      }

      this.enterFns(e, refKey, "select");
    },
    // 默认查省级
    getProvince(e) {
      this.$API
        .district({
          parentId: 1,
        })
        .then((res) => {
          this.SuperiorRegionList = res || [];
        });
    },
    // 获取市 (收货地址)
    getCityName(e, type) {
      if (!e) {
        return false;
      }
      this.$API
        .district({
          parentName: e,
        })
        .then((res) => {
          const data = res || [];
          const fieldName = "cityNameList" + (type ? "_" + type : "");
          this[fieldName] = data;
        });
    },
    // 获取市 (收货地址)
    getAreaName(e, type) {
      if (!e) {
        return false;
      }
      this.$API
        .district({
          parentName: e,
        })
        .then((res) => {
          const data = res || [];
          const fieldName = "areaNameList" + (type ? "_" + type : "");
          this[fieldName] = data;
        });
    },
    // 选择省(收货地址)
    changeProvince(type) {
      let obj = this.sendAddr;
      if (type === 1) {
        obj = this.receiveAddr;
      }
      if (type === 2) {
        obj = this.takeAddr;
      }
      obj.cityName = "";
      obj.areaName = "";
      if (type) {
        this.cityNameList = [];
        this.areaNameList = [];
      } else {
        this["cityNameList_" + type] = [];
        this["areaNameList_" + type] = [];
      }
      const provinceName = obj.provinceName;
      if (provinceName) {
        this.getCityName(provinceName, type);
      }
    },
    // 选择市(收货)
    changeCity(type) {
      let obj = this.sendAddr;
      if (type === 1) {
        obj = this.receiveAddr;
      }
      if (type === 2) {
        obj = this.takeAddr;
      }
      obj.areaName = "";
      if (type) {
        this.areaNameList = [];
      } else {
        this["areaNameList_" + type] = [];
      }
      const cityName = obj.cityName;
      if (cityName) {
        this.getAreaName(cityName, type);
      }
    },

    changeArea(e) {
      this.$forceUpdate();
    },

    //收发货地址
    handleCloseDia3() {
      this.isShowDialog3 = false;
      this.queryData = {
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      };
    },
    handleCloseDiaAI() {
      this.isShowDialogAI = false;
    },
    handleCloseDiaMap() {
      this.isShowDialogMap = false;
    },
    //收发货地址  弹窗确认保存事件
    diaConfirmBtn3() {
      // 添加费项
      this.isShowDialog3 = false;
    },

    diaConfirmBtnAI() {
      this.isShowDialogAI = false;
      // 回填地址
      const address = {
        companyName: "",
        personnelName: this.addressAI.username,
        tel: this.addressAI.phone,
        provinceName: this.addressAI.province,
        cityName: this.addressAI.city,
        areaName: this.addressAI.area,
        address: this.addressAI.address,
        idNumber: this.addressAI.idNumber,
        addressType: this.addressAI.addressType,
      };
      this.changeAddress(address);
    },
    diaConfirmBtnMap() {},
    changeRnRquireConf(e, refKey) {
      if (!e) {
        this.baseInfo.rnRequireName = "";
        this.delService("回单费");
      }
      const rnQuirement = this.rnRequirements.filter(
        (item) => item.id == this.baseInfo.rnRequireConfDictId
      )[0];
      this.baseInfo.rnRequireName = rnQuirement.val;
      // 有回单要求，有回单要求为2元（含开单服务费）
      this.addService({
        itemCategoryName: "服务费",
        itemServiceName: "回单费",
        amount: 1,
        sort: 2,
      });

      this.enterFns(e, refKey, "select");
    },
    changeEndDept(e, refKey) {
      this.changeSendMethod();
      if (refKey) {
        this.enterFns(e, refKey, "select");
      }
    },
    changeSelectKey(e, refKey) {
      if (refKey) {
        this.enterFns(e, refKey, "select");
      }
    },
    changeSendMethod_Fn(e, refKey) {
      this.changeSendMethod();
      if (refKey) {
        this.enterFns(e, refKey, "select");
      }
    },
    changeSendMethod() {
      const sendMethods = this.sendMethods.filter(
        (item) => item.id === this.baseInfo.sendMethodConfDictId
      );
      if (sendMethods.length == 0) {
        return;
      }
      const sendMethod = sendMethods[0];
      if (sendMethod.key !== "客户自提") {
        return;
      }
      const depts = this.businessDepts.filter(
        (item) => item.deptId === this.baseInfo.endDeptId
      );
      if (depts.length === 0) {
        return;
      }
      const dept = depts[0];
      // 设置自提默认
      this.takeAddr = {
        addrId: this.takeAddr.addrId,
        serialNumber: "1",
        contacts: dept.chargePersonName || "",
        company: dept.deptName || "",
        tel: dept.takeGoodsTel || "",
        provinceName: dept.provinceName || "",
        cityName: dept.cityName || "",
        areaName: dept.areaName || "",
        address: dept.address || "",
        operationType: this.takeAddr.addrId ? "UPDATE" : "ADD",
      };
    },
    //收发货地址  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn3() {
      this.isShowDialog3 = false;
    },
    //收发货地址 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    //收发货地址 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //收发货地址 选择收件人地址
    changeRecAddress(type) {
      if (type == 1) {
        this.dialogTitle3 = "选择发货地址";
        this.queryData.addressType = "ji_jian:address_type";
      } else {
        this.dialogTitle3 = "选择收货地址";
        this.queryData.addressType = "shou_jian:address_type";
      }
      this.queryData.customerId = this.baseInfo.customerId || "";
      if (this.baseInfo.customerId) {
        this.isShowDialog3 = true;
        this.getCustomerListAddress();
        this.getCustomerAddrList();
      } else {
        if (this.baseInfo.customerName) {
          this.$message.warning("当前客户没有客户档案").showClose = true;
        } else {
          this.$message.warning("请先选择客户").showClose = true;
        }

        return false;
      }
    },
    //收发货地址 选择地址
    changeAddress(row, ignorePersonInfo = false) {
      if (
        this.queryData.addressType == "ji_jian:address_type" ||
        row.addressType === "ji_jian:address_type"
      ) {
        //寄件
        if (!ignorePersonInfo) {
          this.sendAddr.company = row.companyName || row.deptName;
          this.sendAddr.contacts = row.personnelName || "";
          this.sendAddr.tel = row.tel || "";
          this.sendAddr.idNumber = row.idNumber || "";
        }
        this.sendAddr.provinceName = row.provinceName || "";
        this.sendAddr.cityName = row.cityName || "";
        this.sendAddr.areaName = row.areaName || "";
        this.sendAddr.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName(row.provinceName);
        this.getAreaName(row.cityName);
      } else if (
        this.queryData.addressType == "shou_jian:address_type" ||
        row.addressType === "shou_jian:address_type"
      ) {
        //收件
        if (!ignorePersonInfo) {
          console.log(row);
          this.receiveAddr.company = row.companyName || row.deptName;
          this.receiveAddr.contacts = row.personnelName || "";
          this.receiveAddr.tel = row.tel || "";
          this.receiveAddr.idNumber = row.idNumber || "";
        }
        this.receiveAddr.provinceName = row.provinceName || "";
        this.receiveAddr.cityName = row.cityName || "";
        this.receiveAddr.areaName = row.areaName || "";
        this.receiveAddr.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName(row.provinceName, 1);
        this.getAreaName(row.cityName, 1);
      } else {
        // 自提
        if (!ignorePersonInfo) {
          this.takeAddr.company = row.companyName || row.deptName;
          this.takeAddr.contacts = row.personnelName || "";
          this.takeAddr.tel = row.tel || "";
          this.takeAddr.idNumber = row.idNumber || "";
        }
        this.takeAddr.provinceName = row.provinceName || "";
        this.takeAddr.cityName = row.cityName || "";
        this.takeAddr.areaName = row.areaName || "";
        this.takeAddr.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName(row.provinceName, 2);
        this.getAreaName(row.cityName, 2);
      }
    },
    //收发货地址 获取客户档案列表()
    getCustomerListAddress(name) {
      this.$API
        .wtl_getCustomerList({
          customerName: name || "",
          approveStatus: "tong_guo:approve_status", //审核通过
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.addressNaemList = res.data.result.data || [];
        });
    },
    //收发货地址 收-发货人列表
    getCustomerAddrList() {
      this.$API
        .wtl_getCustomerAddrList({
          customerId: this.queryData.customerId,
          addressType: this.queryData.addressType,
          deptName: this.queryData.deptName,
          personnelName: this.queryData.personnelName,
        })
        .then((res) => {
          this.tableData = res.data.result.data || [];
          this.pageCount_as = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            let Heigth = this.$refs.myDialogRef_as.offsetHeight || 0; //弹窗的高度
            this.TBHeight_as = Heigth * 1 - 51 - 54 - 40;
          });
        });
    },

    // 收录客户地址
    autoAddCustomerAddrApi(datas) {
      return this.$API
        .autoAddCustomerAddr({
          address: datas.address || "",
          addressType: datas.addressType || "",
          cityName: datas.cityName || "",
          contacts: datas.contacts || "",
          customerId: datas.customerId || "",
          provinceName: datas.provinceName || "",
          tel: datas.tel || "",
          addressName: datas.addressName || "",
          areaName: datas.areaName || "",
          phone: datas.tel || "",
          remarks: datas.remarks || "",
          deptName: datas.deptName || datas.companyName || "",
          idNumber: datas.idNumber || "",
        })
        .then((res) => {});
    },
    saveClick(key) {
      //新增
      this.saveKeys = key;
      this.disabledSee = false;
      // switch (key) {
      //   case 1:

      //     break;
      //   case 2:
      //     break;
      //   case 3:
      //     break;
      // }
    },
    async check() {
      let forms = [1, 2, 4, 5, 7, 8];
      if (this.feeCheckIn) {
        forms = [5];
      }
      if (this.baseEdit) {
        forms = [1, 2, 4, 7];
      }
      const promise = forms.map(async (i) => {
        let form = this.$refs["form" + i];
        if (!form) {
          return true;
        }
        const validate = form.validate();
        if (!validate) {
          return true;
        }
        const pro = await validate
          .then((res) => {
            return true;
          })
          .catch((err) => {
            return false;
          });
        return pro;
      });
      const result = await Promise.all(promise);
      const valid = result.filter((item) => !item).length === 0;
      if (!valid) {
        this.$message.warning("请完善信息").showClose = true;
      }
      return valid;
    },
    getOperationType(item) {
      const operationType = item.operationType;
      if (
        !operationType ||
        operationType === "UNCHANGE" ||
        operationType === "UNCHANGED"
      ) {
        return "UPDATE";
      }
      return operationType;
    },
    getOperationTypeParams(item) {
      return {
        ...item,
        operationType: this.getOperationType(item),
      };
    },
    // 提交
    async submit(back) {
      const this_ = this;
      const check = await this.check();
      if (!check) {
        return;
      }
      const files = this.fileNameLists;
      if (this.baseInfo.commandId) {
        this.baseInfo.commandIds = [this.baseInfo.commandId];
      }
      let params = {
        isPosting: 0,
        baseInfo: this.baseInfo,
        sendAddrs: [
          {
            ...this.sendAddr,
            serialNumber: 1,
            operationType: this.getOperationType(this.sendAddr),
            items: this.sendAddrs.map((item) => {
              const aa = this.getOperationTypeParams(item);
              const itemSpecss = item.itemSpecss;
              aa.itemSpecss = itemSpecss.map((specs) => {
                return this.getOperationTypeParams(specs);
              });
              return aa;
            }),
          },
        ],
        receiveAddr: {
          ...this.receiveAddr,
          serialNumber: 1,
        },
        takeAddr: {
          ...this.takeAddr,
          serialNumber: 1,
        },
        transportInfo: this.transportInfo,
        financeInInfo: this.financeInInfo,
        financeOutInfos: this.financeOutInfos.map((item) => {
          return this.getOperationTypeParams(item);
        }),
        files,
        otherInfo: this.otherInfo,
      };
      params = JSON.parse(JSON.stringify(params));
      // 特殊化处理
      this.preProcess(params);
      if (this.waybillSplitId && this.type !== "copy") {
        params.baseInfo.waybillSplitId = this.waybillSplitId;
        params.waybillSplitId = this.waybillSplitId;
        if (this.type === "edit" || this.baseEdit) {
          this.$API.updateWaybill(params).then((res) => {
            this.$message.success(
              res.data.message || "修改成功"
            ).showClose = true;
            if (back === false) {
              return;
            }
            this.reset();
            this.toList();
          });
        } else {
          this.$API.updateWaybillFinance(params).then((res) => {
            this.$message.success(
              res.data.message || "修改成功"
            ).showClose = true;
            if (back === false) {
              return;
            }
            this.reset();
            this.toList();
          });
        }
      } else {
        await this.$API.addWaybill(params).then((res) => {
          if (this_.baseInfo.customerId) {
            this.autoSaveAddress();
          }
          this.baseInfo.waybillSplitId = res.data.result.waybillSplitId;
          if (back === false) {
            return;
          }
          this.$confirm("新建成功 ", "提示：", {
            confirmButtonText: "查看列表",
            cancelButtonText: "继续新建",
          })
            .then(() => {
              this_.$message.success(
                res.data.message || "新增成功"
              ).showClose = true;
              this.reset();
              this.toList();
            })
            .catch(() => {
              this.reset();
            });
        });
      }
    },
    async saveAndPrintIt(command) {
      await this.submit(false);
      this.printIt(command);
    },
    autoSaveAddress() {
      const this_ = this;
      if (this_.isAutoAddr_jj) {
        // 自动收录收件地址
        this_.autoAddCustomerAddrApi({
          customerId: this_.baseInfo.customerId || "",
          addressType: "ji_jian:address_type",
          address: this_.sendAddr.address || "",
          cityName: this_.sendAddr.cityName || "",
          contacts: this_.sendAddr.contacts || "",
          provinceName: this_.sendAddr.provinceName || "",
          tel: this_.sendAddr.tel || "",
          addressName: "", //地址简称
          areaName: this_.sendAddr.areaName || "",
          phone: this_.sendAddr.tel || "",
          deptName:
            this_.sendAddr.company ||
            this_.sendAddr.companyName ||
            this._sendAddr.deptName,
          idNumber: this_.sendAddr.idNumber,
          remarks: "",
        });
      }
      if (this_.isAutoAddr_sj) {
        // 自动收录收件地址
        this_.autoAddCustomerAddrApi({
          customerId: this_.baseInfo.customerId || "",
          addressType: "shou_jian:address_type",
          address: this_.receiveAddr.address || "",
          cityName: this_.receiveAddr.cityName || "",
          contacts: this_.receiveAddr.contacts || "",
          provinceName: this_.receiveAddr.provinceName || "",
          tel: this_.receiveAddr.tel || "",
          addressName: "", //地址简称
          areaName: this_.receiveAddr.areaName || "",
          phone: this_.receiveAddr.tel || "",
          deptName:
            this_.receiveAddr.company ||
            this_.receiveAddr.companyName ||
            this_.receiveAddr.deptName,
          idNumber: this_.receiveAddr.idNumber,
          remarks: "",
        });
      }
    },
    preProcess(params) {
      if (params.baseInfo.customerId === "") {
        params.baseInfo.customerId = null;
      }
      let financeInInfo = params.financeInInfo;
      if (financeInInfo) {
        financeInInfo.unitPrice = this.dealZeroWhileEmpty(
          financeInInfo.unitPrice
        );
        financeInInfo.basicFreight = this.dealZeroWhileEmpty(
          financeInInfo.basicFreight
        );
        financeInInfo.takeFee = this.dealZeroWhileEmpty(financeInInfo.takeFee);
        financeInInfo.sendFee = this.dealZeroWhileEmpty(financeInInfo.sendFee);
        financeInInfo.transferFee = this.dealZeroWhileEmpty(
          financeInInfo.transferFee
        );
        financeInInfo.agentAmount = this.dealZeroWhileEmpty(
          financeInInfo.agentAmount
        );
        financeInInfo.agentServiceRate = this.dealZeroWhileEmpty(
          financeInInfo.agentServiceRate
        );
        financeInInfo.agentServiceFee = this.dealZeroWhileEmpty(
          financeInInfo.agentServiceFee
        );
        financeInInfo.insuranceFee = this.dealZeroWhileEmpty(
          financeInInfo.insuranceFee
        );
        financeInInfo.allOtherFee = this.dealZeroWhileEmpty(
          financeInInfo.allOtherFee
        );
        financeInInfo.serviceFee = this.dealZeroWhileEmpty(
          financeInInfo.serviceFee
        );
        financeInInfo.senderAmount = this.dealZeroWhileEmpty(
          financeInInfo.senderAmount
        );
        financeInInfo.receivedAmount = this.dealZeroWhileEmpty(
          financeInInfo.receivedAmount
        );
        financeInInfo.monthlyAmount = this.dealZeroWhileEmpty(
          financeInInfo.monthlyAmount
        );
        financeInInfo.rnorderAmount = this.dealZeroWhileEmpty(
          financeInInfo.rnorderAmount
        );
        financeInInfo.goodsDeductedAmoun = this.dealZeroWhileEmpty(
          financeInInfo.goodsDeductedAmoun
        );
        financeInInfo.declaredValue = this.dealZeroWhileEmpty(
          financeInInfo.declaredValue
        );
        financeInInfo.declaredValueRate = this.dealZeroWhileEmpty(
          financeInInfo.declaredValueRate
        );
      }
    },
    // 重置页面
    toList() {
      //this.$TOOLS.closePage();
      this.$BaseIndex.closeCurrentTab("/WaybillManage/ComprehensiveQuery");
    },
    reset() {
      this.$emit("reset");
    },
    calcVolumeWeight(pos) {
      let sendAddr = {};
      const { volume, ratio } = (sendAddr = this.sendAddrs[pos]);
      console.log(volume, ratio);
      if (volume && ratio) {
        sendAddr.volumeWeight = volume * ratio;
      }
    },
    go2AddressAI(type) {
      this.isShowDialogAI = true;
      if (type == 1) {
        this.addressAI.addressType = "ji_jian:address_type";
      } else {
        this.addressAI.addressType = "shou_jian:address_type";
      }
    },
    go2Map(type) {
      this.isShowDialogMap = true;
      if (type == 1) {
        this.addressMap.addressType = "ji_jian:address_type";
      } else if (type == 2) {
        this.addressMap.addressType = "shou_jian:address_type";
      } else {
        this.addressMap.addressType = "self_take:address_type";
      }
    },
    chooseAddress(options) {
      this.isShowDialogMap = false;
      // 回填地址
      const address = {
        provinceName: options.province,
        cityName: options.city,
        areaName: options.district,
        address: options.address,
        addressType: this.addressMap.addressType,
      };
      this.changeAddress(address, true);
    },
    go2AddressBook(type) {
      this.isShowDialog3 = true;
    },
    clearAddressAIText() {
      this.addressAI.addressBefore = "";
    },
    analysisAddress() {
      const addressBefore = this.addressAI.addressBefore;
      const addressAfter = AddressParse.parse(addressBefore)[0];
      this.addressAI.username = addressAfter.name;
      this.addressAI.phone = addressAfter.mobile || addressAfter.phone;
      this.addressAI.province = addressAfter.province;
      this.addressAI.city = addressAfter.city;
      this.addressAI.area = addressAfter.area;
      this.addressAI.address = addressAfter.details;
      this.$forceUpdate();
    },
    async getFormulasBillingWeight() {
      const res = await this.$API.runList({
        number: "formula_billing_weight_down_list",
      });
      this.formulasBillingWeight = res;
    },
    changeBILLMethode(val) {
      const item = this.formulasBillingWeight.filter(
        (item) => item.formulaBillingWeightId == val
      )[0];
      this.financeInInfo.formulaBillingWeightName =
        item.formulaBillingWeightName;
    },
    // 计算货物信息表格的运费
    getGoodsTable(a, b) {
      let num1 = this.financeInInfo.billingWeight || 0; //计费取值
      let num2 = this.financeInInfo.unitPrice || 0; //单价
      //this.goodsInfoList[a].itemReqs[b].freight = this.$TOOLS.mul(num1, num2);
      //this.getBasicFreight();
    },
    // 税金
    // getTaxes() {
    //   let num1 = this.CaiWuData.totalFreight || 0; //运费合计
    //   let num2 = this.CaiWuData.invoiceTaxPoint || 0; //税点
    //   let num3 = this.$TOOLS.divide(num2, 100);
    //   this.CaiWuData.taxes = this.$TOOLS.mul(num1, num3).toFixed(2);
    // },
    // 计算:基本运费
    getBasicFreight() {},
    // 计算:运费合计
    getTotalFreight() {
      const baseFee = parseInt(this.financeInInfo.basicFreight || 0);
      const takeFee = parseInt(this.financeInInfo.takeFee || 0);
      const sendFee = parseInt(this.financeInInfo.sendFee || 0);
      const transferFee = parseInt(this.financeInInfo.transferFee || 0);
      const insuranceFee = parseInt(this.financeInInfo.insuranceFee || 0);
      const allOtherFee = parseInt(this.financeInInfo.allOtherFee || 0);
      const serviceFee = this.getService() || 0;
      const total =
        baseFee +
        takeFee +
        sendFee +
        transferFee +
        insuranceFee +
        allOtherFee +
        serviceFee;
      this.financeInInfo.totalFreight = total;
      this.setupFee(true);
      this.$forceUpdate();
    },
    changeReceivedCustomer() {},
    // 费型类型下拉列表
    itemCategorChoose(categoryName) {
      this.$API
        .itemCategorChoose({ categoryName: categoryName })
        .then((res) => {
          this.categoryNameList = res.data.result || [];
        });
    },
    AddServiceFee() {
      this.isShowDialog7 = true;
    },
    // 添加一应收费项
    AddFeiXian() {
      this.financeInInfo.otherFeeInfos = this.financeInInfo.otherFeeInfos || [];
      this.otherFeeInfos =
        JSON.parse(JSON.stringify(this.financeInInfo.otherFeeInfos)) || [];
      this.otherFeeInfos_1 = this.otherFeeInfos.filter(
        (item) => item.operationType != "DEL"
      );
      this.isShowDialog6 = true;
      this.dialogTitle6 = "新建应收费项";
      this.dialogType = "add";
      this.itemCategorChoose(); //费型类型下拉列表
    },
    EditFeiXian(row, deitIdx) {
      this.isShowDialog6 = true;
      this.dialogTitle6 = "编辑应收费项";
      this.dialogType = "edit";
      this.deitIdx = deitIdx;
      this.dialogForm2 = JSON.parse(JSON.stringify(row));
      this.financeOutInfos_1 = [
        {
          ...row,
        },
      ];
      this.itemCategorChoose(); //费型类型下拉列表
    },
    // 添加应付弹窗
    addYinFu() {
      this.isShowDialog2 = true;
      this.dialogTitle2 = "新建应付";
      this.dialogType2 = "add";
      this.financeOutInfos_1 = [
        {
          amount: null,
          inoutStatus: "zhi_chu:deal_status",
          itemCategoryId: null,
          itemCategoryName: null,
          itemServiceId: null,
          itemServiceName: null,
          objectName: null,
          objectNumber: null,
          objectStatusConfDictId: null,
          paymentMethodConfDictId: null,
          remarks: null,
          objectStatusType: null, //对象类型(我自己加的)
          paymentMethod: null, //付款方式名称(我自己加的)
          files: [],
          preparerEmployeeId: this.$TOOLS.getUserInfo().employeeId,
        },
      ];
      this.itemCategorChoose(); //费型类型下拉列表
      this.getConfDictValDownList("object_status", "objectStatusList"); //结算对象类型
    },
    // 删除一行货物信息
    delFeiXian(row) {
      // this.CaiWuData.itemServiceReqs.splice(idx2, 1);
      // this.getOtherExpenses();
      row.operationType = "DEL";
      this.financeOutInfos_2 = this.financeOutInfos.filter(
        (item) => item.operationType != "DEL"
      );
    },
    // 删除一行货物信息
    delFeiXian2(idx2) {
      this.financeOutInfoReqs.splice(idx2, 1);
    },
    editFeiXian(row, idx) {
      this.isShowDialog2 = true;
      this.dialogTitle2 = "编辑应付";
      this.dialogType2 = "edit";
      this.editYfIdx = idx;
      this.dialogForm2 = JSON.parse(JSON.stringify(row)); //如果不转表格跟弹窗的数据会一起变
      //this.dialogForm2.itemCategoryId = parseInt(row.itemCategoryId) || ''
      this.dialogForm2.objectStatusConfDictId =
        parseInt(row.objectStatusConfDictId) || null;
      this.dialogForm2.preparerEmployeeId =
        parseInt(row.preparerEmployeeId) || null;
      this.dialogForm2.paymentMethodConfDictId =
        parseInt(row.paymentMethodConfDictId) || null;
      this.dialogForm2.objectStatusTypeName = row.objectStatusTypeName;
      this.dialogForm2.objectStatusType = row.objectStatusType;
      this.dialogForm2.files = row.files;
      this.dialogForm2.id = row.id;
      this.financeOutInfos_1 = [
        {
          ...row,
        },
      ];
      this.itemCategorChoose(); //费型类型下拉列表
      this.getConfDictValDownList("object_status", "objectStatusList"); //结算对象类型
      this.getObjectUserDownListYf(); //获取结算对象
      this.wtl_itemServiceListAll(row.itemCategoryId, "fu:direction_status"); //获取费项(应收)
      this.editYfRow = row;
    },
    /***
     * 应付
     */
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        // 弹窗表单数据
        amount: null,
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        objectName: null,
        objectNumber: null,
        objectStatusConfDictId: null,
        paymentMethodConfDictId: null,
        remarks: null,
        objectStatusType: null, //对象类型(我自己加的)
        paymentMethod: null, //付款方式名称(我自己加的)
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 编辑
          if (this.dialogForm2.id) {
            Object.assign(
              this.editYfRow,
              this.financeOutInfos_1[0],
              this.dialogForm2,
              { operationType: "UPDATE" }
            );
          } else {
            this.financeOutInfos_1.map((item) => {
              this.financeOutInfos.push({
                ...item,
                ...this.dialogForm2,
                operationType: "ADD",
              });
            });
            this.financeOutInfos_2 = this.financeOutInfos.filter(
              (item) => item.operationType != "DEL"
            );
          }
          this.isShowDialog2 = false;
          this.financeOutInfos_1 = [];
        }
      });
    },
    // 选择结算方式
    changeSettlementMethod(e) {
      let val = null;
      this.settlementMethods.forEach((item) => {
        if (item.id == this.financeInInfo.settlementMethodConfDictId) {
          val = item.key;
        }
      });
      this.amountIsAble = true;
      if (val === "ji_fu_yue_jie") {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "月结费",
          amount: 1,
          sort: 4,
        });
      } else {
        // 删除月结费
        this.delService("月结费");
      }
      this.senderAmountDisable = true;
      this.receivedAmountDisable = true;
      this.monthlyAmountDisable = true;
      this.rnorderAmountDisable = true;
      this.goodsDeductedAmounDisable = true;
      this.financeInInfo.senderAmount = 0;
      this.financeInInfo.receivedAmount = 0;
      this.financeInInfo.monthlyAmount = 0;
      this.financeInInfo.rnorderAmount = 0;
      this.financeInInfo.goodsDeductedAmoun = 0;
      this.getTotalFreight();
      this.setupFee();
    },
    setupFee(donotCleaar = false) {
      let val = null;
      this.settlementMethods.forEach((item) => {
        if (item.id == this.financeInInfo.settlementMethodConfDictId) {
          val = item.key;
        }
      });
      // 设置特殊输入规则
      switch (val) {
        // 现结
        case "ji_fu_xian_jie":
          this.financeInInfo.senderAmount = this.financeInInfo.totalFreight;
          this.senderAmountDisable = false;
          break;
        case "ji_fu_yue_jie":
          this.financeInInfo.monthlyAmount = this.financeInInfo.totalFreight;
          this.monthlyAmountDisable = false;
          break;
        case "ji_fu_hui_dan_jie":
          this.financeInInfo.rnorderAmount = this.financeInInfo.totalFreight;
          this.rnorderAmountDisable = false;
          break;
        case "dao_fu_xian_jie":
          this.financeInInfo.receivedAmount = this.financeInInfo.totalFreight;
          this.receivedAmountDisable = false;
          break;
        case "dao_fu_yue_jie":
          this.financeInInfo.receivedAmount = this.financeInInfo.totalFreight;
          this.receivedAmountDisable = false;
          // 选择月结客户
          break;
        case "duo_bi_fu":
          this.senderAmountDisable = false;
          this.receivedAmountDisable = false;
          this.monthlyAmountDisable = false;
          this.rnorderAmountDisable = false;
          this.goodsDeductedAmounDisable = false;
          if (!donotCleaar) {
            this.financeInInfo.senderAmount = null;
            this.financeInInfo.receivedAmount = null;
            this.financeInInfo.monthlyAmount = null;
            this.financeInInfo.rnorderAmount = null;
            this.financeInInfo.goodsDeductedAmoun = null;
          }
          break;
        case "dai_shou_huo_kuan_kou":
          this.financeInInfo.goodsDeductedAmoun =
            this.financeInInfo.totalFreight;
          this.goodsDeductedAmounDisable = false;
          break;
        case "mian_fei":
          break;
      }
    },
    changeInsure() {
      if (!this.financeInInfo.isInsure) {
        this.financeInInfo.declaredValue = 0;
        this.financeInInfo.declaredValueRate = 0;
      }
      this.getBXFee();
    },
    getBXFee() {
      const declareVal = this.financeInInfo.declaredValue;
      const rate = this.financeInInfo.declaredValueRate;
      if (!declareVal || !rate) {
        this.financeInInfo.insuranceFee = 0;
        return;
      }
      const isSure = this.financeInInfo.isSure;
      if (isSure == 0) {
        this.financeInInfo.insuranceFee = 0;
        return;
      }
      this.financeInInfo.insuranceFee = ((declareVal * rate) / 1000).toFixed(2);
      if (this.financeInInfo.insuranceFee < 0.01) {
        this.financeInInfo.insuranceFee = 0.01;
      }
    },
    // 应付费用表格合计
    getFeesPaySummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.feesPayableTableTo.length; i++) {
          if (column.property === that.feesPayableTableTo[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.add(prev, curr);
                  // return this.$TOOLS.mathToFixed(
                  //   this.$TOOLS.add(prev, curr),
                  //   2
                  // );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.feesPayableTable.doLayout();
      });
      return sums;
    },
    changeBusinessMan() {},
    changeMerchandiserEmployee() {},
    changeHandlingEmployee() {},
    // 选择结算对象类型
    changeObjestStatus(e) {
      this.dialogForm2.objectName = "";
      this.dialogForm2.objectNumber = "";
      this.dialogForm2.objectStatusType = "";
      this.dialogForm2.objectStatusTypeName = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.id == e) {
            this.dialogForm2.objectStatusType = item.key;
            this.dialogForm2.objectStatusTypeName = item.val;
          }
        });
        this.getObjectUserDownListYf();
      }
    },
    delService(name) {
      let pos = null;
      for (let i = 0; i < this.serviceFees.length; i++) {
        const serviceFee = this.serviceFees[i];
        if (name === serviceFee.itemServiceName) {
          pos = i;
          break;
        }
      }
      if (pos !== null) {
        this.serviceFees.splice(pos, 1);
      }
    },
    addService(serviceFee) {
      const exist =
        this.serviceFees.filter(
          (item) => item.itemServiceName === serviceFee.itemServiceName
        ).length > 0;
      if (exist) {
        return;
      }
      this.serviceFees.push(serviceFee);
      this.serviceFees_1 = this.serviceFees.sort((a, b) => {
        return a.sort - b.sort;
      });
    },
    addCategory() {
      this.financeOutInfos_1.push({});
    },
    delCategory(pos) {
      this.financeOutInfos_1.splice(pos, 1);
    },
    handleConfirmYingShouu() {
      this.financeInInfo.otherFeeInfos = JSON.parse(
        JSON.stringify(this.otherFeeInfos)
      );
      let allOtherFee = 0;
      this.otherFeeInfos
        .filter((item) => item.operationType != "DEL")
        .forEach((item) => (allOtherFee += parseFloat(item.amount)));
      this.financeInInfo.allOtherFee = allOtherFee;
      this.isShowDialog6 = false;
      this.dialogForm6 = {
        itemCategoryId: "",
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        remarks: null,
        amount: null,
      };
      this.otherFeeInfos = [];
      this.otherFeeInfos_1 = this.otherFeeInfos.filter(
        (item) => item.operationType != "DEL"
      );
    },
    handleCloseYingShou() {
      this.isShowDialog6 = false;
      this.dialogForm6 = {
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        remarks: null,
        amount: null,
      };
      this.otherFeeInfos = [];
      this.otherFeeInfos_1 = this.otherFeeInfos.filter(
        (item) => item.operationType != "DEL"
      );
    },
    addOtherFeeInfo() {
      this.otherFeeInfos.push({
        ...this.dialogForm6,
        operationType: "ADD",
      });
      this.otherFeeInfos_1 = this.otherFeeInfos.filter(
        (item) => item.operationType != "DEL"
      );
    },
    delOtherFeeInfo(row) {
      row.operationType = "DEL";
      this.otherFeeInfos_1 = this.otherFeeInfos.filter(
        (item) => item.operationType != "DEL"
      );
    },
    handleCloseService() {
      this.isShowDialog7 = false;
    },
    changeIntoStorage(e) {
      if (!e) {
        this.delService("入仓费");
      } else {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "入仓费",
          amount: 9,
          sort: 3,
        });
      }
    },
    calcAgentService() {
      const amount = this.financeInInfo.agentAmount || 0;
      const rate = this.financeInInfo.agentServiceRate || 0;
      const total = this.$TOOLS.mul(amount, rate);
      this.financeInInfo.agentServiceFee = this.$TOOLS
        .divide(total, 1000)
        .toFixed(2);
      this.getTotalFreight();
    },
    printIt(command) {
      if (!this.baseInfo.waybillSplitId) {
        this.$message.warning("请先保存").showClose = true;
        return;
      }
      this.modelClassName = this.classNameArr.filter(
        (item) => item.name === command
      )[0].val;
      this.printEvent();
    },
    printDataSource(rows) {
      if (
        this.modelClassName ===
        "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillHkPrintDataV5VO"
      ) {
        return new Promise((resolve, reject) => {
          this.$API
            .hkPrintData({
              waybillSplitIds: [this.baseInfo.waybillSplitId],
            })
            .then((res) => {
              const result = res.data.result;
              resolve(result);
            })
            .catch((err) => {});
        });
      }
      return new Promise((resolve, reject) => {
        this.$API
          .runList({
            number: "admin_waybill_list_v5",
            waybillSplitIds: [this.baseInfo.waybillSplitId],
          })
          .then((res) => {
            const result = res;
            resolve(result);
          })
          .catch((err) => {});
      });
    },
    async printEvent() {
      // 获取数据
      if (
        this.modelClassName ===
        "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillHkPrintDataV5VO"
      ) {
        this.$API
          .hkPrintData({
            waybillSplitIds: [this.baseInfo.waybillSplitId],
          })
          .then((res) => {
            const result = res.data.result;
            this.$refs.myPrint.printEvent(result);
          })
          .catch((err) => {});
      }
      this.$API
        .runList({
          number: "admin_waybill_list_v5",
          waybillSplitIds: [this.baseInfo.waybillSplitId],
        })
        .then((res) => {
          const result = res;
          console.log(result);
          this.$refs.myPrint.printEvent(result);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.topBtns {
  width: calc(100% - 240px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}

.form_head {
  .waybill_Type {
    margin-bottom: 10px;
    width: fit-content;
    color: #ff0000;
    font-weight: bold;
    border: 2px dashed transparent;
    border-radius: 5px;
    padding: 2px 12px;
    background: linear-gradient(#fff, #fff) padding-box,
      repeating-linear-gradient(
        -75deg,
        #ff0000 0,
        #ff0000 0.9em,
        #fff 0,
        #fff 1.2em
      );
  }
  .head_formBox {
    justify-content: space-between;
    .el-form-item {
      margin-bottom: 20px;
      width: 18%;
      min-width: unset;
      margin-right: unset;
      overflow: unset;
    }
  }
}
.all_div {
  border: 1px solid #f59a23;
}

.infoDiv {
  border-width: 1px 1px 0 1px;
  border-style: solid;
  border-color: #f59a23;
  display: flex;
  .h3title {
    background: #f9c99d;
    margin: 0;
    color: #fff;
    width: 40px;
    font-size: 18px;
    display: flex;
    align-items: center;
    // background-color: #f2f2f2;
    padding: 5px;
    // padding: 10px;
    // border-bottom: 1px solid @borderColor;
    font-weight: bold;
    // margin-bottom: 20px;
  }

  .formbox {
    // padding: 0 30px;
    padding: 0 10px;
    width: calc(100% - 70px);
    .glo_formBox {
      .double_item {
        /deep/.el-form-item__content {
          display: flex;
          .el-select {
            input {
              //padding-left: 5px;
            }
          }
          .second_ipt {
            input {
              padding-left: 5px;
              padding-right: 10px;
            }
          }
          .unit {
            margin-right: 5px;
          }
        }
      }
      .Divider {
        width: 100%;
        height: 1px;
        margin-bottom: 10px;
        border-top: 1px dashed transparent;
        background: linear-gradient(#fff, #fff) padding-box,
          repeating-linear-gradient(
            -75deg,
            #797979 0,
            #797979 0.9em,
            #fff 0,
            #fff 1.2em
          );
      }
    }
    .head_formBox {
      justify-content: flex-start;
      margin: 15px 0 5px 0;
      .el-form-item {
        // width: 18%;
        width: calc(24% - 2px);
        min-width: unset;
        margin-bottom: 20px;
        overflow: unset;
      }
    }
    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  }

  .goodsItmes {
    margin: 10px 0;
    // margin-top: 30px;
    // border-bottom: 4px solid #ccc;
    // padding-bottom: 20px;
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .miniInput {
    width: 80px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-right: 2px;

    text-align: center;

    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0 5px;
    }
  }
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectAddress {
  border: 1px solid #ccc;
  margin-right: 10px;
  width: 180px !important;
}
.addressDetails {
  //   width: 380px !important;
  flex: 1;
}

.btmBtns {
  text-align: center;
  margin-top: 50px;

  .saveBtns {
    font-size: 16px;
  }
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
    cursor: pointer;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.addTiHuoDiZhi {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}

.textArea {
  height: 100%;
}

.glo_btnItems {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}

.goodsTable {
  /deep/ .el-table {
    width: 100%;
    .cell {
      padding-right: 0;
      padding-left: 0;
    }
  }
}

// #tables {
//   .glo_formBox {
//     /deep/ .el-input__icon {
//       line-height: 30px !important;
//     }
//   }
// }
.linkTabel {
  text-align: center;
  cursor: pointer;
}
/deep/ .el-input__icon {
  line-height: 30px !important;
}

.disFlex {
  display: flex;
  align-items: center;
}

.checkBox {
  margin-left: 30px;
}

#tiHuoForm {
  padding: 10px;
  border: 1px dashed @borderColor;
  margin: 0 45px 10px 30px;
}
.address-ai-input {
  width: 100%;
  border: none;
}
.address-ai-button-container {
  text-align: right;
  padding: 5px 8px 5px 5px;
}
.address-ai-form {
  .el-form-item {
    margin-bottom: 1px;
    ::v-deep .el-form-item__label {
      text-align: right;
    }
  }
}
.item-category-container {
  ::v-deep .el-input__inner {
    width: 200px;
  }
}
.amp-map-dialog {
  /deep/ .el-dialog__body {
    max-height: calc(100vh - 120px);
  }
}

.tranfserTb {
  display: flex;
  justify-content: center;
  // align-items: center;

  .tranfser_tit {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .tranfser_item {
    flex: 1;
  }

  .tranfser_center {
    width: 140px;

    display: flex;
    align-items: center;
    justify-content: center;

    .btnA {
      padding: 10px;
    }
  }
}

@tbBorder: #ebeef5;
.daraStyle_H {
  background-color: #f0f0f0;
}
// 拖拽
.daraStyle_1 {
  height: 34px;
  line-height: 34px;
  border-bottom: none;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid @tbBorder;
  cursor: grab;

  .daraNum_1 {
    width: 60px;
    text-align: center;
  }

  .cloWidth_1 {
    flex: 1;
    text-align: left;
    border-left: 1px solid @tbBorder;
    border-right: 1px solid @tbBorder;
    padding: 0 20px;
  }
  .icon_del {
    width: 50px;
    text-align: center;
    cursor: pointer;
  }

  .el-icon-delete {
    font-size: 20px;
  }
}
.daraStyle_1:hover {
  background-color: #f2f2f2;
}

// .daraStyle_1:last-of-type {
//   border-bottom: 1px solid @tbBorder;
// }

.draggableClass {
  border: 1px solid @tbBorder;
}

/deep/ .el-input__inner:focus {
  // border-color: #409eff; /* 你可以自定义这个颜色 */
  box-shadow: 0 0 0 2px #ef7c0a; /* 聚焦时的阴影效果 */
}
</style>
